<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <section id="description">
        <div class="row">
          <div class="col-md-8">
            <div class="card custom-card">
              <form ref="updateForm" @submit.prevent="updateJobAd">
                <div class="job-content">
                  <div class="d-none d-sm-block">
                    <div class="col-md-12">
                      <div class="header-title d-flex">
                        <Avatar :photo="selectedAvatar" :employer="selectedId" />
                        <div
                          class="header-title-name d-flex align-items-center"
                          v-if="!isInGlobalEditMode"
                        >
                          <b>{{ getJobAdById.title }}</b>
                          <span class="job-edit ml-2">
                            <router-link to>
                              <svgHelper
                                @click.native="changeGlobalEditMode"
                                class="job-edit-icon"
                                name="edit"
                              />
                            </router-link>
                          </span>
                        </div>
                        <div class="d-flex flex-grow-1 name-edit" v-else>
                          <input
                            type="text"
                            class="form-control"
                            id="job_name"
                            placeholder="Title"
                            v-model="selectedJobTitle"
                          />

                          <!-- Btns -->
                          <div
                            class="form-buttons text-right ml-auto w-50"
                            v-show="isInGlobalEditMode"
                          >
                            <button type="submit" class="btn btn-primary mr-2">Save</button>
                            <button class="btn btn-danger" @click="isInGlobalEditMode = false">
                              Cancel
                            </button>
                            <br />
                            <i
                              style="cursor: pointer; font-size: 21px"
                              data-toggle="modal"
                              href="#deleteJobModal"
                              class="fas fa-trash-alt mt-2"
                            ></i>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <select
                            :disabled="getAccType !== 'admin'"
                            v-show="!isInGlobalEditMode"
                            class="form-control select-style pr-4"
                            v-model="selectedServiceLevel"
                            style="width: 120px; box-shadow: none"
                            @change="onChangeJobServiceLevel"
                          >
                            <option value="0">Basic</option>
                            <option value="1">Sourcing</option>
                            <option value="2">Full-service</option>
                            <option value="3">Nearshore</option>
                            <option value="4">Freelancers</option>
                          </select>

                          <select
                            v-show="!isInGlobalEditMode"
                            class="form-control select-style pr-4"
                            @change="onChangeJobStatus"
                            v-model="selectedJobStatus"
                            style="width: 120px; box-shadow: none"
                          >
                            <option
                              v-for="option in jobStatusOptions"
                              :key="option.value"
                              :value="option.value"
                            >
                              {{ option.label }}
                            </option>
                          </select>

                          <!-- Add Job btn -->
                          <button
                            type="button"
                            class="btn btn-success text-nowrap d-none d-sm-block"
                            @click="onShowAdJobModal"
                            v-if="!isInGlobalEditMode"
                          >
                            Add Job
                            <portal to="add-job-modal">
                              <CustomMainModal @close="showModal = false" v-show="showModal">
                                <template v-slot:header>
                                  <h5>Add Job</h5>
                                </template>

                                <AddJobBtnModal v-if="showModal" />
                              </CustomMainModal>
                            </portal>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <nav class="job-controls-tabs">
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-primary-tab"
                        data-toggle="tab"
                        href="#nav-primary"
                        role="tab"
                        aria-controls="nav-primary"
                        aria-selected="true"
                        ><i class="far fa-credit-card d-block d-sm-none"></i> PRIMARY</a
                      >
                      <a
                        @click="getDevSkillerTests"
                        class="nav-item nav-link"
                        id="nav-requirements-tab"
                        data-toggle="tab"
                        href="#nav-requirements"
                        role="tab"
                        aria-controls="nav-requirements"
                        aria-selected="false"
                        ><i class="far fa-file-alt d-block d-sm-none"></i> REQUIREMENTS</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-ad-tab"
                        data-toggle="tab"
                        href="#nav-ad"
                        role="tab"
                        aria-controls="nav-ad"
                        aria-selected="false"
                        ><i class="far fa-file-alt d-block d-sm-none"></i> JOB AD</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-advertising-tab"
                        data-toggle="tab"
                        href="#nav-advertising"
                        role="tab"
                        aria-controls="nav-advertising"
                        aria-selected="false"
                        ><i class="far fa-file-alt d-block d-sm-none"></i> Advertising</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-comments-tab"
                        data-toggle="tab"
                        href="#nav-comments"
                        role="tab"
                        aria-controls="nav-comments"
                        aria-selected="false"
                        ><i class="fas fa-comments d-block d-sm-none"></i> COMMENTS
                        <span
                          v-show="getJobAdCommentsList.length ? true : false"
                          class="badge badge-light"
                          >{{ getJobAdCommentsList.length }}</span
                        ></a
                      >

                      <a
                        class="nav-item nav-link mobile-only"
                        id="nav-pipelines-tab"
                        data-toggle="tab"
                        href="#nav-pipelines"
                        role="tab"
                        aria-controls="nav-pipelines"
                        aria-selected="false"
                        ><i class="fas fa-sliders-h d-block d-sm-none"></i> Pipelines</a
                      >
                      <a
                        class="nav-item nav-link mobile-only"
                        id="nav-activity-tab"
                        data-toggle="tab"
                        href="#nav-activity"
                        role="tab"
                        aria-controls="nav-activity"
                        aria-selected="false"
                        ><i class="fas fa-chart-bar d-block d-sm-none"></i> activities</a
                      >
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-primary"
                      role="tabpanel"
                      aria-labelledby="nav-primary-tab"
                    >
                      <div class="mobile-clear">
                        <div class="row">
                          <div class="col-md-12">
                            <div
                              class="single-job-controls d-flex align-items-center d-block d-sm-none"
                            >
                              <select class="form-control select-style" v-model="selectedJobStatus">
                                <option>Active</option>
                                <option>Submitted</option>
                                <option>Published</option>
                                <option>Rejected</option>
                                <option>Closed</option>
                              </select>

                              <!-- Add Job btn -->
                              <button
                                style="right: 14px"
                                type="button"
                                class="btn btn-success text-nowrap ml-3"
                                @click="showModal = true"
                              >
                                Add Job
                                <portal to="add-job-modal">
                                  <CustomMainModal @close="showModal = false" v-show="showModal">
                                    <template v-slot:header>
                                      <h5>Add Job</h5>
                                    </template>
                                    <AddJobBtnModal />
                                  </CustomMainModal>
                                </portal>
                              </button>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <ul class="list-group list-group-flush job-details">
                              <div class="row">
                                <li class="list-group-item col-md-6" style="padding-right: 0">
                                  <div
                                    v-if="!editIconState.employerFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.employer = true"
                                    @mouseleave="editFields.employer = false"
                                    class="d-flex"
                                  >
                                    <span>Employer</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.employer" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="employer"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <router-link
                                        class="username"
                                        :to="{
                                          name: 'employer_id',
                                          params: { employer_id: getJobAdById.js_employer_id },
                                        }"
                                        >{{ getJobAdById.employer_name }}</router-link
                                      >
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Employer</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      id="employer"
                                      placeholder="Employer"
                                      :value="jobAdData.employer_name"
                                      disabled
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.employerFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.city = true"
                                    @mouseleave="editFields.city = false"
                                    class="d-flex"
                                  >
                                    <span>Location</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.city" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="city"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div>
                                        {{ getLocation(jobAdData.city, jobAdData.country) }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex new-location" v-else>
                                    <span class="mr-0">
                                      <b>Location</b>
                                    </span>
                                    <div class="location-container">
                                      <v-select
                                        class="country-select mr-1"
                                        v-model="selectedCountry"
                                        @input="
                                          fetchCitiesByCountryId($event);
                                          clearCity();
                                        "
                                        label="name"
                                        :options="getAllCountries"
                                        :reduce="country => country"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options="{ search, searching }">
                                          <template v-if="searching && search.length >= 3">
                                            No results found for <em>{{ search }}</em
                                            >.
                                          </template>
                                          <div style="opacity: 0.5" v-else>
                                            Please type at least 3 characters
                                          </div>
                                        </template>
                                      </v-select>
                                      <v-select
                                        class="city-select"
                                        label="name"
                                        v-model="selectedCity"
                                        :options="getCitiesListByCountry"
                                        :reduce="city => city"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options>
                                          <div style="opacity: 0.5">
                                            Please select a country first
                                          </div>
                                        </template>
                                      </v-select>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.cityFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.postalFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.postal = true"
                                    @mouseleave="editFields.postal = false"
                                    class="d-flex"
                                  >
                                    <span>Postal code</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.postal" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="postal"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.postal_code }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Postal code</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Postal code"
                                      v-model="selectedPostalCode"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.postalFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.streetFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.street = true"
                                    @mouseleave="editFields.street = false"
                                    class="d-flex"
                                  >
                                    <span>Street address</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.street" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="street"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.street ? getJobAdById.street : '' }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Street address </b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Street address"
                                      v-model="selectedAddress"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.streetFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.individualsFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.individuals = true"
                                    @mouseleave="editFields.individuals = false"
                                    class="d-flex"
                                  >
                                    <span>No of individuals</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.individuals" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="need-individuals"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.individuals_number }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span> No of individuals </span>

                                    <input
                                      type="text"
                                      class="form-control w-100"
                                      v-model="selectedIndividuals"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.individualsFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.employmentFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.employment = true"
                                    @mouseleave="editFields.employment = false"
                                    class="d-flex"
                                  >
                                    <span>Employment</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.employment" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="employment"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getEmploymentType(getJobAdById.employment_type) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Employment</b>
                                    </span>

                                    <select
                                      class="form-control w-100"
                                      style="padding-left: 7px"
                                      v-model="selectedEmploymentType"
                                      id="employment_type"
                                    >
                                      <option :value="1">Employment</option>
                                      <option :value="2">Self-employment</option>
                                      <option :value="3">Employment / Self-Employment</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.employmentFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.durationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.duration = true"
                                    @mouseleave="editFields.duration = false"
                                    class="d-flex"
                                  >
                                    <span>Duration </span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.duration" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="duration"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ calculateDuration(getJobAdById.duration) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Duration</span>

                                    <select
                                      id="full-time"
                                      v-model="selectedDuration"
                                      class="form-select w-100"
                                    >
                                      <option value="1">Permanent employment</option>
                                      <option value="2">Time-limited employment</option>
                                      <option value="3">Less than 1 month</option>
                                      <option value="4">1-3 months</option>
                                      <option value="5">3-6 months</option>
                                      <option value="6">6-12 months</option>
                                      <option value="7">More than 12 months</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.durationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.fullTimeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.fullTime = true"
                                    @mouseleave="editFields.fullTime = false"
                                    class="d-flex"
                                  >
                                    <span>Full-time</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.fullTime" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="fullTime"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.full_time ? 'Yes' : 'No' }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Full time</span>

                                    <select
                                      class="form-control w-100"
                                      v-model="selectedFullTime"
                                      style="box-shadow: none"
                                    >
                                      <option :value="true">Yes</option>
                                      <option :value="false">No</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.fullTimeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.workplaceFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.workplace = true"
                                    @mouseleave="editFields.workplace = false"
                                    class="d-flex"
                                  >
                                    <span>Workplace</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.workplace" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="workplace"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ showWorkPlace(getJobAdById.workplace) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Workplace</span>
                                    <select
                                      class="form-control w-100"
                                      v-model="selectedWorkplace"
                                      style="box-shadow: none"
                                    >
                                      <option value="1">Onsite</option>
                                      <option value="2">Hybrid</option>
                                      <option value="3">Remote</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.workplaceFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.relocationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.relocation = true"
                                    @mouseleave="editFields.relocation = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Relocation</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.relocation" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="relocation"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span style="font-weight: 400">{{
                                        getJobAdById.relocation ? 'Yes' : 'No'
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      Relocation
                                    </span>

                                    <div class="custom-control custom-checkbox">
                                      <input
                                        id="relocation-checkbox"
                                        class="custom-control-input"
                                        type="checkbox"
                                        aria-label
                                        :checked="selectedRelocation"
                                        v-model="selectedRelocation"
                                      />
                                      <label
                                        class="custom-control-label mr-2"
                                        for="relocation-checkbox"
                                      ></label>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.relocationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="
                                      !editIconState.recruitingFeeFormShow && !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.recruitingFee = true"
                                    @mouseleave="editFields.recruitingFee = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Recruiting fee</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.recruitingFee" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="rFee"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span
                                        v-if="jobAdData.recruiting_fee"
                                        style="font-weight: 400"
                                        >{{ formatPrice(jobAdData.recruiting_fee) }}</span
                                      >
                                    </div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Recruiting fee</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="selectedRecruitingFee"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.recruitingFeeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="!editIconState.startingFeeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.startingFee = true"
                                    @mouseleave="editFields.startingFee = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Starting fee</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.startingFee" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="stFee"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span
                                        v-if="jobAdData.starting_fee"
                                        style="font-weight: 400"
                                        >{{ formatPrice(jobAdData.starting_fee) }}</span
                                      >
                                    </div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Starting fee</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="selectedStartingFee"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.startingFeeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="
                                      !editIconState.proggramingTestFormShow && !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.programmingTestFee = true"
                                    @mouseleave="editFields.programmingTestFee = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Test fee</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.programmingTestFee" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="prFee"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span
                                        v-if="jobAdData.programming_test_fee"
                                        style="font-weight: 400"
                                        >{{ formatPrice(jobAdData.programming_test_fee) }}</span
                                      >
                                    </div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Programming test fee</b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="selectedProgrammingTestFee"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.proggramingTestFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap;">
                                  <div
                                    v-if="!editIconState.currencyFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.currency = true"
                                    @mouseleave="editFields.currency = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Currency</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.currency" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="currency"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span style="font-weight: 400">
                                        {{
                                          jobAdData.currency_id !== null &&
                                          jobAdData.currency &&
                                          jobAdData.currency.code &&
                                          jobAdData.currency.code.length > 0
                                            ? jobAdData.currency.code
                                            : ''
                                        }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Currency</b>
                                    </span>

                                    <v-select
                                      style="width: 100%;"
                                      v-model="selectedCurrency"
                                      id="currency"
                                      label="code"
                                      :options="currencies"
                                    ></v-select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.currencyFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.anonFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.anon = true"
                                    @mouseleave="editFields.anon = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      Anonymize
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.anon" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="anon"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span style="font-weight: 400">{{
                                        getJobAdById.anonymize ? 'Yes' : 'No'
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      Anonymize
                                    </span>

                                    <div class="custom-control custom-checkbox">
                                      <input
                                        id="relocation-checkbox"
                                        class="custom-control-input"
                                        type="checkbox"
                                        aria-label
                                        :checked="selectedAnon"
                                        v-model="selectedAnon"
                                      />
                                      <label
                                        class="custom-control-label mr-2"
                                        for="relocation-checkbox"
                                      ></label>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.anonFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.createdByFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.createdBy = true"
                                    @mouseleave="editFields.createdBy = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Created by</b>
                                    </span>

                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.createdBy" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="created-by"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.created_by }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Created by</b>
                                    </span>

                                    <input
                                      disabled
                                      :value="getJobAdById.created_by"
                                      id="created-by"
                                      type="text"
                                      class="form-control mr-1"
                                    />
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.createdByFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.createdAtFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.createdAt = true"
                                    @mouseleave="editFields.createdAt = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Created date</b>
                                    </span>

                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.createdAt" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="created-date"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        jobAdData.created_at
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Created date</b>
                                    </span>

                                    <input
                                      type="text"
                                      id="created-date"
                                      class="form-control"
                                      :value="
                                        jobAdData.created_at
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      disabled
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.createdAtFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>
                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.lastUpdatedFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.lastUpdated = true"
                                    @mouseleave="editFields.lastUpdated = false"
                                    class="d-flex"
                                  >
                                    <span>Last updated</span>

                                    <div class="custom-control icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.lastUpdated" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="lastUpdated"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        jobAdData.updated_at
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span>Last updated</span>

                                    <input
                                      disabled
                                      :value="
                                        jobAdData.updated_at
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      type="text"
                                      class="form-control mr-1"
                                    />
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.lastUpdatedFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- COMMENTS TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-comments"
                      role="tabpanel"
                      aria-labelledby="nav-comments-tab"
                    >
                      <Comments
                        :key="key"
                        @add-candidate-comment="addCommentHandler"
                        @remove-comment="deleteCommentHandler"
                        @edit-comment="editCommentHandler"
                        :uuid="this.$route.params.job_uuid"
                        :commentsList="getJobAdCommentsList"
                      />
                    </div>
                    <!-- END COMMENTS TAB BODY -->

                    <!-- REQUIREMENTS TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-requirements"
                      role="tabpanel"
                      aria-labelledby="nav-requirements-tab"
                    >
                      <div class="mobile-clear">
                        <div class="row">
                          <div class="col-md-12">
                            <section>
                              <div class="description-text">
                                <h6 class="d-none d-block d-sm-none req-mobile">Requirements</h6>
                              </div>
                              <ul
                                style="min-height: 70vh"
                                class="list-group list-group-flush job-details job-details-description"
                              >
                                <li class="list-group-item border-top-0">
                                  <div
                                    v-if="
                                      !editIconState.yearsOfExperianceFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.yearsOfExperiance = true"
                                    @mouseleave="editFields.yearsOfExperiance = false"
                                    class="d-flex"
                                  >
                                    <span>Years of experience</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link
                                          v-if="editFields.yearsOfExperiance"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="years-of-experience"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.years_experience }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-2"> Years of experience </span>

                                    <div>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="selectedYearsExperience"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.yearsOfExperianceFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <!--  -->

                                <!--  -->
                                <li class="list-group-item">
                                  <div
                                    v-if="!editIconState.degreeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.degree = true"
                                    @mouseleave="editFields.degree = false"
                                    class="d-flex"
                                  >
                                    <span>Degree</span>

                                    <div
                                      style="min-width:500px"
                                      class="d-flex align-items-center icon-container"
                                    >
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.degree" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="degreeField"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getDegreeName(getJobAdById.degree_type) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Degree</b>
                                    </span>

                                    <div>
                                      <select
                                        id="degree-type"
                                        v-model="selectedDegreeType"
                                        class="form-select w-100"
                                        style="box-shadow: none"
                                      >
                                        <option :value="0">Select Degree type</option>
                                        <option :value="1">University</option>
                                        <option :value="2">Bachelor's degree</option>
                                        <option :value="3">Master's degree</option>
                                        <option :value="4">PhD</option>
                                      </select>
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.degreeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <!--   <span class="item-title">Degree field</span>
                                <span class="item-body">{{ getJobAdById.degree_field }}</span> -->

                                  <div
                                    v-if="!editIconState.degreeFieldFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.degreeField = true"
                                    @mouseleave="editFields.degreeField = false"
                                    class="d-flex"
                                  >
                                    <span>Degree field</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.degreeField" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="degree-field"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.degree_field }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Degree field</b>
                                    </span>

                                    <div>
                                      <input
                                        id="selected-degree-field"
                                        type="text"
                                        class="form-control w-100"
                                        v-model="selectedDegreeField"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.degreeFieldFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <div
                                    v-if="
                                      !editIconState.competencesRequiredFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.competencesRequired = true"
                                    @mouseleave="editFields.competencesRequired = false"
                                    class="d-flex"
                                  >
                                    <span>Required competencies</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link
                                          v-if="editFields.competencesRequired"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="competences-required"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getJobAdById.required_competences"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getJobAdById.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex issue" v-else>
                                    <span class="mr-0">
                                      <b>Required competencies</b>
                                    </span>

                                    <v-select
                                      v-model="selectedCompetences"
                                      label="name"
                                      :options="getCompetencesFilterList"
                                      :reduce="competence => competence"
                                      :clearable="true"
                                      multiple
                                      id="add-job-competences"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.competencesRequiredFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <div
                                    v-if="
                                      !editIconState.competencesAdvantageFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.competencesAdvantage = true"
                                    @mouseleave="editFields.competencesAdvantage = false"
                                    class="d-flex"
                                  >
                                    <span>Advantage competencies</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link
                                          v-if="editFields.competencesAdvantage"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="competences-advantage"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getJobAdById.advantage_competences"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getJobAdById.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex issue" v-else>
                                    <span class="mr-0">
                                      <b>Advantage competencies</b>
                                    </span>
                                    <v-select
                                      v-model="selectedCompetencesAdvantage"
                                      label="name"
                                      :options="getCompetencesFilterList"
                                      :reduce="competence => competence"
                                      :clearable="true"
                                      multiple
                                      id="add-job-competences-advantage"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.competencesAdvantageFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item border-bottom d-flex align-items-center">
                                  <div
                                    v-if="!editIconState.languagesFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.languages = true"
                                    @mouseleave="editFields.languages = false"
                                    class="d-flex"
                                  >
                                    <span>Language skills</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.languages" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="languages"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getJobAdById.languages"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getJobAdById.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex issue" v-else>
                                    <span class="mr-0">
                                      <b>Language skills</b>
                                    </span>

                                    <v-select
                                      v-model="selectedLanguages"
                                      label="name"
                                      :options="getLanguagesList"
                                      :reduce="language => language"
                                      :clearable="true"
                                      multiple
                                      id="add-job-competences-advantage"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.languagesFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item border-bottom d-flex align-items-center">
                                  <div
                                    v-if="!editIconState.devskillerFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.devskiller = true"
                                    @mouseleave="editFields.devskiller = false"
                                    class="d-flex"
                                  >
                                    <span>DevSkiller</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.devskiller" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="devskiller"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div style="min-width: 500px" v-if="selectedTest">
                                        {{ selectedTest.name }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex issue" v-else>
                                    <span class="mr-0">
                                      <b>DevSkiller</b>
                                    </span>

                                    <v-select
                                      class="city-select"
                                      label="name"
                                      v-model="selectedTest"
                                      :options="DevSkillerTests"
                                      :reduce="test => test"
                                      :clearable="false"
                                      placeholder="Select DevSkiller test"
                                    >
                                      <template v-slot:no-options>
                                        <div style="opacity: 0.5">
                                          Select DevSkiller test
                                        </div>
                                      </template>
                                    </v-select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.devskillerFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <!--   <span class="item-title">Degree field</span>
                                <span class="item-body">{{ getJobAdById.degree_field }}</span> -->

                                  <div
                                    v-if="!editIconState.summaryFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.summaryField = true"
                                    @mouseleave="editFields.summaryField = false"
                                    class="d-flex"
                                    style="height:auto"
                                  >
                                    <span style="align-self: flex-start;">Summary</span>

                                    <div
                                      class="d-flex align-items-center icon-container"
                                      style="flex:1"
                                    >
                                      <div class="edit-btn">
                                        <router-link v-if="editFields.summaryField" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="summary"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getJobAdById.summary }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Summary</b>
                                    </span>

                                    <div>
                                      <input
                                        id="selected-summary"
                                        type="text"
                                        class="form-control w-100"
                                        v-model="selectedSummary"
                                        autocomplete="off"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.summaryFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                              </ul>
                            </section>

                            <!-- GLOBAL EDIT MODE -->
                            <!--  <section v-else>
                            <div class="description-text">
                              <h6 class="d-none d-block d-sm-none req-mobile">Requirements</h6>
                            </div>
                            <ul class="list-group list-group-flush job-details">
                                <li class="list-group-item border-top-0 d-flex align-items-center">
                                <span class="item-title">Years of experience</span>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="selectedYearsExperience"
                                />
                              </li>
                               <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Degree</span>
                                <span class="item-body">
                                  <select
                                    id="degree-type"
                                    v-model="selectedDegreeType"
                                    class="form-select w-100"
                                    style="box-shadow: none"
                                  >
                                    <option :value="0">Select Degree type</option>
                                    <option :value="1">University</option>
                                    <option :value="2">Bachelor's degree</option>
                                    <option :value="3">Master's degree</option>
                                    <option :value="4">PhD</option>
                                  </select>
                                </span>
                              </li>
                              <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Degree field</span>

                                <input
                                  id="selected-degree-field"
                                  type="text"
                                  class="form-control w-100"
                                  v-model="selectedDegreeField"
                                />
                              </li>

                              <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Competences required</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedCompetences"
                                    label="name"
                                    :options="getCompetencesFilterList"
                                    :reduce="(competence) => competence"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences"
                                  />
                                </div>
                              </li>

                               <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Competences advantage</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedCompetencesAdvantage"
                                    label="name"
                                    :options="getCompetencesFilterList"
                                    :reduce="(competence) => competence"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences-advantage"
                                  />
                                </div>
                              </li>
                              <li class="list-group-item border-bottom d-flex align-items-center">
                                <span class="item-title">Languages</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedLanguages"
                                    label="name"
                                    :options="getLanguagesList"
                                    :reduce="(language) => language"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences-advantage"
                                  />
                                </div>
                              </li>
                            </ul>
                          </section> -->
                            <!-- END GLOBAL EDIT MODE -->
                          </div>
                        </div>
                        <!-- <JobItemRequirements /> -->
                      </div>
                    </div>
                    <!-- END REQUIREMENTS TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-advertising"
                      role="tabpanel"
                      aria-labelledby="nav-advertising-tab"
                    >
                      <div class="mobile-clear">
                        <div class="form-group row advertising">
                          <div class="row">
                            <div class="col-md-12">
                              <h2 class="jobshark-header">Jobshark</h2>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Submitted date
                                </label>
                                <div class="col-md-9">
                                  <p
                                    v-if="getJobAdById.submitted_date"
                                    style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                  >
                                    {{
                                      getJobAdById.submitted_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}
                                  </p>
                                  <p
                                    v-else
                                    style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                  >
                                    N/A
                                  </p>
                                </div>
                              </div>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Approval date
                                </label>
                                <div class="col-md-9">
                                  <p
                                    style="font-size: 1rem; font-weight: 400; color: #495057;  margin-bottom: 0;"
                                  >
                                    {{
                                      getJobAdById.published_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}
                                  </p>
                                </div>
                              </div>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Rejected date</label
                                >
                                <div class="col-md-9">
                                  <p
                                    v-if="getJobAdById.rejected_date"
                                    style="font-size: 1rem; font-weight: 400; color: #495057;  margin-bottom: 0;"
                                  >
                                    {{
                                      getJobAdById.rejected_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}
                                  </p>
                                  <p
                                    v-else
                                    style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                  >
                                    N/A
                                  </p>
                                </div>
                              </div>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Advertising start date
                                </label>
                                <div class="col-md-9">
                                  <p
                                    v-if="getJobAdById.advertizing_start_date"
                                    style="font-size: 1rem; font-weight: 400; color: #495057;  margin-bottom: 0;"
                                  >
                                    {{
                                      getJobAdById.advertizing_start_date
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}
                                  </p>
                                  <p
                                    v-else
                                    style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                  >
                                    N/A
                                  </p>
                                </div>
                              </div>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Advertising end date
                                </label>
                                <div class="col-md-3">
                                  <div
                                    v-if="isInGlobalEditMode"
                                    class="d-flex"
                                    style="position: relative;"
                                  >
                                    <date-picker
                                      v-model="selectedEndDate"
                                      :not-before="plats_advertising.startDate"
                                      value-type="date"
                                      valueType="format"
                                      :format="getUserProfile.format_date"
                                      :placeholder="getUserProfile.format_date"
                                    ></date-picker>
                                  </div>
                                  <div v-if="!isInGlobalEditMode">
                                    <p
                                      v-if="getJobAdById.advertizing_end_date"
                                      style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                    >
                                      {{
                                        getJobAdById.advertizing_end_date
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </p>
                                    <p
                                      v-else
                                      style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                    >
                                      N/A
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group row align-items-center">
                                <label for="title" class="col-md-3 col-form-label">
                                  Promoted
                                </label>
                                <div class="col-md-9">
                                  <p
                                    v-if="!isInGlobalEditMode"
                                    style="font-size: 1rem; font-weight: 400; color: #495057; margin-bottom: 0;"
                                  >
                                    {{ getJobAdById.promoted ? 'Yes' : 'No' }}
                                  </p>
                                  <div v-else>
                                    <div class="custom-control custom-checkbox">
                                      <input
                                        id="promo-checkbox"
                                        class="custom-control-input"
                                        type="checkbox"
                                        aria-label
                                        :checked="selectedPromoted"
                                        v-model="selectedPromoted"
                                      />
                                      <label
                                        class="custom-control-label mr-2"
                                        for="promo-checkbox"
                                      ></label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <h2 class="jobshark-header">Platsbanken</h2>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="title" class="col-md-3 col-form-label">
                              Published
                            </label>
                            <div class="col-md-9">
                              <p style="font-size: 1rem; font-weight: 400; color: #495057;">
                                {{ plats_advertising.published ? 'Yes' : 'No' }}
                              </p>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="title" class="col-md-3 col-form-label">
                              Title
                            </label>
                            <div class="col-md-9">
                              <input
                                type="text"
                                class="form-control"
                                id="title"
                                placeholder="Title"
                                v-model="plats_advertising.title"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Profession
                            </label>
                            <div class="col-md-9 no-flow">
                              <v-select
                                v-model="plats_advertising.professionId"
                                :options="allProfessions"
                                placeholder="All professions"
                                inputId="employer-select"
                                label="name"
                                :clearable="false"
                              >
                                <!--              <template #option="{ name, code }">
                                  {{ name }} {{ `(${code})` }}
                                </template> -->
                              </v-select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Municipality
                            </label>
                            <div class="col-md-9">
                              <v-select
                                v-model="plats_advertising.manu"
                                :options="sortedManipucility"
                                placeholder="Municipality"
                                inputId="emp1loyer-select"
                                label="taxonomy/preferred-label"
                              >
                                <!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> -->
                              </v-select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Wage type
                            </label>
                            <div class="col-md-9">
                              <select v-model="plats_advertising.wage" class="form-control">
                                <option value="oG8G_9cW_nRf">Fixed salary</option>
                                <option value="vVtj_qm6_GQu">Variable salary</option>
                                <option value="asrX_9Df_ukn">Fixed and variable salary</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Duration
                            </label>
                            <div class="col-md-9">
                              <select v-model="plats_advertising.duration" class="form-control">
                                <option value="a7uU_j21_mkL">Permanent employment</option>
                                <option value="qQUd_4qe_NDT">6 months or more</option>
                                <option value="Xj7x_7yZ_jEn">3-6 months</option>
                                <option value="Sy9J_aRd_ALx">11 days-3 months</option>
                                <option value="cAQ8_TpB_Tdv">max 10 days</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Worktime extent
                            </label>
                            <div class="col-md-9">
                              <select v-model="plats_advertising.worktime" class="form-control">
                                <option value="6YE1_gAC_R2G">Full-time</option>
                                <option value="947z_JGS_Uk2">Part-time</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Skills
                            </label>
                            <div class="col-md-9 no-flow">
                              <v-select
                                v-model="plats_advertising.skills"
                                :options="platsbankenSkills"
                                placeholder="All skills"
                                inputId="emp1loyer-select"
                                label="name"
                                multiple
                                :reduce="option => option.code"
                              >
                                <!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> -->
                              </v-select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="profession" class="col-md-3 col-form-label">
                              Experience
                            </label>
                            <div class="col-md-9">
                              <select v-model="plats_advertising.experience" class="form-control">
                                <option value="9myv_bKh_YHf">No experience required</option>
                                <option value="yrAe_Fzi_E6u">Less than 1 year experience</option>
                                <option value="LLnd_5GJ_4ju">1-2 years of experience</option>
                                <option value="RWA2_uu6_udD">2-4 years of experience</option>
                                <option value="8CVf_zRX_aZj">5 years of experience or more</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="start-date" class="col-md-3 col-form-label">
                              Start date
                            </label>
                            <div class="col-md-9 d-flex">
                              <input
                                placeholder="Start date"
                                v-model="plats_advertising.startDate"
                                readonly="true"
                                type="text"
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="end-date" class="col-md-3 col-form-label">
                              End date
                            </label>
                            <div class="col-md-9 d-flex" style="position: relative;">
                              <date-picker
                                v-model="plats_advertising.endDate"
                                :not-before="plats_advertising.startDate"
                                value-type="date"
                                valueType="format"
                                :format="getUserProfile.format_date"
                                :placeholder="getUserProfile.format_date"
                              ></date-picker>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label for="tracking" class="col-md-3 col-form-label">
                              Tracking string
                            </label>
                            <div class="col-md-9">
                              <input
                                type="text"
                                class="form-control"
                                id="tracking"
                                placeholder="Tracking string"
                                v-model="plats_advertising.tracking"
                              />
                            </div>
                          </div>
                          <div class="form-group row view-link">
                            <label
                              for="link"
                              class="col-md-3 col-form-label"
                              style="position:relative;"
                            >
                              Link to ad
                              <!--                               <span
                                v-show="!plats_advertising.editLink"
                                class="show"
                                style="position:absolute;right:-5px; cursor:pointer; color:#666; opacity:0"
                              >
                                <i
                                  @click="plats_advertising.editLink = true"
                                  class="fas fa-pen edit-icon"
                                ></i
                              ></span> -->
                            </label>
                            <div class="col-md-9">
                              <div
                                v-if="plats_advertising.editLink"
                                class="d-flex align-items-center"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="link"
                                  placeholder="Link to ad"
                                  v-model="plats_advertising.link"
                                />
                                <button
                                  @click="savePlats"
                                  type="button"
                                  class="btn btn-outline btn-sm border mr-1 ml-1"
                                >
                                  <i class="fas fa-check"></i>
                                </button>

                                <button
                                  type="button"
                                  class="btn btn-outline btn-sm border"
                                  @click="plats_advertising.editLink = false"
                                >
                                  <i class="fas fa-times"></i>
                                </button>
                              </div>

                              <div v-else class="form-control">
                                <a target="_blank" rel="nofollow" :href="plats_advertising.link">{{
                                  plats_advertising.link
                                }}</a>
                              </div>
                            </div>
                          </div>

                          <div
                            class="form-group"
                            style="display: flex;
    flex-direction: column;"
                          >
                            <button
                              @click="copyOriginal"
                              class="btn btn-secondary ml-auto mb-2 mt-2"
                            >
                              Copy Job Ad
                            </button>

                            <Editor v-model="plats_advertising.description" />
                          </div>

                          <!--  <textarea>
                            {{ testjson.payload }}
                          </textarea> -->

                          <div v-if="getAccType === 'admin'">
                            <div class="form-group">
                              <div class="d-flex" style="justify-content: flex-end;">
                                <button
                                  v-if="plats_advertising.published"
                                  data-bs-toggle="modal"
                                  data-bs-target="#publishToStop"
                                  type="button"
                                  class="btn btn-danger"
                                >
                                  Stop Publishing
                                </button>
                                <button
                                  data-bs-toggle="modal"
                                  data-bs-target="#publishTo"
                                  type="button"
                                  class="btn btn-secondary ml-3"
                                >
                                  {{
                                    plats_advertising.published
                                      ? 'Save and Update'
                                      : 'Save and Publish'
                                  }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-activity"
                      role="tabpanel"
                      aria-labelledby="nav-comments-tab"
                    >
                      <!-- <Activities /> -->
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-ad"
                      role="tabpanel"
                      aria-labelledby="nav-ad-tab"
                    >
                      <div class="description-text col-md-12 mt-5 mx-auto">
                        <div class="d-flex">
                          <h6>Description</h6>
                          <div class="ml-auto buttons mb-2">
                            <div v-if="!editText" class="edit-btn">
                              <router-link to>
                                <i
                                  @click="onEditText(jobAdData.description)"
                                  id="lastUpdated"
                                  class="fas fa-pen edit-icon"
                                  style="color: #666"
                                ></i>
                              </router-link>
                            </div>

                            <div v-else>
                              <button type="submit" class="btn btn-outline btn-sm border mr-1">
                                <i style="color: green" class="fas fa-check"></i>
                              </button>
                              <CandidateEditFieldCancelBtn @clicked="editText = false">
                                <i class="fas fa-times" style="color: red"></i>
                              </CandidateEditFieldCancelBtn>
                            </div>
                          </div>
                        </div>

                        <!-- <div
                                v-if="!editText"
                                class="description-text-body description-scroll"
                                v-html="jobAdData.description"
                              ></div>

                              <div v-show="editText" class="text-editor">
                                <Editor v-model="selectedDescription" />
                              </div> -->

                        <div
                          class="description-text-body description-scroll"
                          v-if="
                            !editIconState.descriptionFormShow && !isInGlobalEditMode && !editText
                          "
                          v-html="jobAdData.description"
                        ></div>

                        <div v-else>
                          <Editor v-model="selectedDescription" />
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-pipelines"
                      role="tabpanel"
                      aria-labelledby="nav-emails-tab"
                    >
                      <h6 class="d-none d-block d-sm-none req-mobile mb-1 aside-title">
                        Pipelines
                      </h6>
                      <!-- <JobItemPipeline></JobItemPipeline> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-4 desktop-only job-aside-activity">
            <Activities
              :isLoading="isLoading"
              @removed-activity="reloadActivity"
              @getActivities="loadMoreActivities"
              :activities="currentActivities"
            />
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>

      <!-- Delete Job Modal -->
      <div
        class="modal fade edit-modal"
        id="deleteJobModal"
        tabindex="-1"
        aria-labelledby="deleteJobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteJobModal">Delete Job</h5>
              <button
                ref="closeModalBtn"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body text-center justify-content-center">
              <p>
                Please confirm that you want to delete <strong>{{ getJobAdById.title }}</strong
                >. This action will permanently delete the information.
              </p>
            </div>
            <div class="modal-footer text-center justify-content-center">
              <button @click="removeJob" type="button" class="btn btn-primary">Delete</button>

              <button
                ref="closeModalBtn"
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End Delete Job Modal -->

      <!-- Pipeline -->
      <div class="desktop-only desktop-pipelines">
        <JobItemPipeline
          @reload-activity="reloadActivity"
          :jobStatus="getJobAdById.status"
          :service_level="getJobAdById.service_level"
          :devSkiller="getJobAdById.devskiller_test_id"
        />
      </div>
    </div>
    <!-- End page-content-wrapper -->
    <portal-target name="add-job-modal"></portal-target>

    <CustomMainModal
      @close="jobStatusModalShow = false"
      v-show="jobStatusModalShow"
      :header="true"
      modalSize="modal-md"
    >
      <template v-slot:header>
        <h5 style="margin-bottom:0!important">Change status</h5>
      </template>
      <p>Please confirm that you want to change status.</p>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" @click="saveNewJobStatus">Confirm</button>
        <button type="button" class="btn btn-secondary" @click="onCancelSetJobStatus">
          Cancel
        </button>
      </div>
      <Spinner :isLoading="isLoading" />
    </CustomMainModal>

    <CustomMainModal
      @close="jobSourcingModalShow = false"
      v-show="jobSourcingModalShow"
      :header="true"
      modalSize="modal-md"
    >
      <template v-slot:header>
        <h5 style="margin-bottom:0!important">Change service level</h5>
      </template>
      <p>Please confirm that you want to change service level.</p>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" @click="updateServiceLevel">Confirm</button>
        <button type="button" class="btn btn-secondary" @click="onCancelSetServiceLevel">
          Cancel
        </button>
      </div>
      <Spinner :isLoading="isLoading" />
    </CustomMainModal>

    <div
      class="modal fade add-user-modal"
      id="publishTo"
      tabindex="-1"
      aria-labelledby="publishTo"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="publishToModal">
              {{ plats_advertising.published ? 'Update Job' : 'Publish Job on Platsbanken' }}
            </h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closePublishTo"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <p>
                Please confirm that you want to
                {{ plats_advertising.published ? 'update' : 'publish' }} the job at Platsbanken with
                current information.
              </p>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              :disabled="isPublishing"
              @click="sentToPlats('active')"
              type="button"
              class="btn btn-primary"
            >
              {{ plats_advertising.published ? 'Update' : 'Publish' }}
            </button>

            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="publishToStop"
      tabindex="-1"
      aria-labelledby="publishToStop"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="publishToStopModal">Stop publishing</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closePublishToStop"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <p>
                Please confirm that you want to stop publishing this job at Platsbanken.
              </p>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="sentToPlats('inactive')" type="button" class="btn btn-primary">
              Stop
            </button>

            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';
import Editor from '@/components/common/TextEditor';
import Sidebar from '../../Navigations/Sidebar';
import TopNavbar from '../../Navigations/TopNavbar';

import AddJobBtnModal from './AddJobBtnModal';
import CustomMainModal from '../../Modals/CustomMainModal';

import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// Activities AND EMAILS
import Activities from '../common/Activities';
/* import Emails from '../common/Emails'; */

/* import JobItemRequirements from '../Jobs/JobItemRequirements'; */
import Comments from '../common/Comments';

// Icons
import IconMapper from '../../common/iconMapper';

// PIPELINE
import JobItemPipeline from '../Jobs/JobItemPipeline';
import { degreeMixin } from '../../../mixins/degreeMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { errorService } from '../../../services/errorService';
import Avatar from './JobAvatar.vue';
import { MESSAGES, LOCATION } from '../../../constants';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';
import moment from 'moment-timezone';
import { get } from 'jquery';
// import moment from 'moment';

export default {
  components: {
    DatePicker,
    Editor,
    IconMapper,
    Sidebar,
    TopNavbar,
    Activities,
    CandidateEditFieldCancelBtn,
    /*  Emails, */
    JobItemPipeline,
    /*  JobItemRequirements, */
    Comments,
    AddJobBtnModal,
    CustomMainModal,
    Avatar,

    /* IconMapper, */
  },
  mixins: [
    toggleSidebarNav,
    degreeMixin,
    stagesMixin,
    employmentMixin,
    jobStatusMixin,
    serviceLevelMixin,
    titleMixin,
  ],
  title() {
    return 'Job | Jobshark';
  },
  data: () => ({
    isPublishing: false,
    currencies: [],
    isSaving: false,
    locationsData: LOCATION,
    editText: false,
    selectedAvatar: null,
    selectedId: '',
    currentActivities: [],
    currentPage: 1,
    pageCount: 10,
    last_page: '',
    editFields: {
      currency: false,
      devskiller: false,
      workplace: false,
      summaryField: false,
      employer: false,
      city: false,
      country: false,
      street: false,
      employment: false,
      advertisingStartDate: false,
      approvalDate: false,
      advertisingEndDate: false,
      promoted: false,
      createdBy: false,
      createdAt: false,
      lastUpdated: false,
      yearsOfExperiance: false,
      degree: false,
      degreeField: false,
      competencesRequired: false,
      competencesAdvantage: false,
      languages: false,
      postal: false,
      relocation: false,
      descriptions: false,
      individuals: false,
      fullTime: false,
      duration: false,
      anon: false,
      startingFee: false,
      recruitingFee: false,
      programmingTestFee: false,
    },
    editIconState: {
      currencyFormShow: false,
      startingFeeFormShow: false,
      recruitingFeeFormShow: false,
      proggramingTestFormShow: false,
      devskillerFormShow: false,
      anonFormShow: false,
      workplaceFormShow: false,
      summaryFormShow: false,
      individualsFormShow: false,
      fullTimeFormShow: false,
      durationFormShow: false,
      employerFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      streetFormShow: false,
      employmentFormShow: false,
      advertisingStartDateFormShow: false,
      approvalDateFormShow: false,
      advertisingEndDateFormShow: false,
      promotedFormShow: false,
      createdByFormShow: false,
      createdAtFormShow: false,
      lastUpdatedFormShow: false,
      yearsOfExperianceFormShow: false,
      degreeFormShow: false,
      degreeFieldFormShow: false,
      competencesRequiredFormShow: false,
      competencesAdvantageFormShow: false,
      languagesFormShow: false,
      postalFormShow: false,
      relocationFormShow: false,
      descriptionFormShow: false,
    },
    jobStatusModalShow: false,
    jobSourcingModalShow: false,
    jobStatusOptions: [
      { value: 0, label: 'Active' },
      { value: 1, label: 'Submitted' },
      { value: 2, label: 'Approved' },
      { value: 3, label: 'Published' },
      { value: 4, label: 'Rejected' },
      { value: 5, label: 'Closed' },
    ],
    key: 0,
    showModal: false,
    isToggled: false,
    isLoading: false,
    isInGlobalEditMode: false,
    actualJobStatus: 0,
    actualServiceLevel: '',
    competencesAdv: [],
    competences: [],
    selectedCity: {},
    selectedCurrency: {},
    selectedJobStatus: 0,
    selectedCountry: '',
    selectedServiceLevel: 1,
    selectedJobTitle: '',
    selectedYearsExperience: '',
    selectedDegreeType: 0,
    selectedDegreeField: '',
    selectedCompetences: [],
    selectedCompetencesAdvantage: [],
    selectedEmploymentType: 1,
    selectedLanguages: [],
    selectedRelocation: false,
    selectedPostalCode: '',
    selectedPromoted: false,
    selectedAddress: '',
    selectedEndDate: '',
    selectedDescription: '',
    selectedIndividuals: 0,
    selectedFullTime: true,
    selectedDuration: '',
    selectedSummary: '',
    selectedWorkplace: '',
    selectedStartingFee: '',
    selectedRecruitingFee: '',
    selectedProgrammingTestFee: '',
    selectedTest: {
      name: '',
      id: '',
    },
    selectedTestId: '',
    dateOne: '',
    selectedAnon: false,
    jobAdData: {},
    plats_advertising: {
      published: false,
      title: '',
      professionId: '',
      startDate: null,
      endDate: null,
      tracking: '',
      link: '',
      manu: '',
      platsbanken_id: '',
      editLink: false,
      /* Taxonomy */
      duration: 'a7uU_j21_mkL',
      wage: 'oG8G_9cW_nRf',
      worktime: '6YE1_gAC_R2G',
      experience: '9myv_bKh_YHf',
      skills: [],
      description: '',
    },
    allProfessions: [],
    platsbankenSkills: [],
    professionId: '',
    professionName: '',
    DevSkillerTests: [],
    testjson: {},

    manipucility: [
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Upplands Väsby',
        'taxonomy/id': 'XWKY_c49_5nv',
        'taxonomy/preferred-label': 'Upplands Väsby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vallentuna',
        'taxonomy/id': 'K4az_Bm6_hRV',
        'taxonomy/preferred-label': 'Vallentuna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Österåker',
        'taxonomy/id': '8gKt_ZsV_PGj',
        'taxonomy/preferred-label': 'Österåker',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Värmdö',
        'taxonomy/id': '15nx_Vut_GrH',
        'taxonomy/preferred-label': 'Värmdö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Järfälla',
        'taxonomy/id': 'qm5H_jsD_fUF',
        'taxonomy/preferred-label': 'Järfälla',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ekerö',
        'taxonomy/id': 'magF_Gon_YL2',
        'taxonomy/preferred-label': 'Ekerö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Huddinge',
        'taxonomy/id': 'g1Gc_aXK_EKu',
        'taxonomy/preferred-label': 'Huddinge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Botkyrka',
        'taxonomy/id': 'CCVZ_JA7_d3y',
        'taxonomy/preferred-label': 'Botkyrka',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Salem',
        'taxonomy/id': '4KBw_CPU_VQv',
        'taxonomy/preferred-label': 'Salem',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Haninge',
        'taxonomy/id': 'Q7gp_9dT_k2F',
        'taxonomy/preferred-label': 'Haninge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tyresö',
        'taxonomy/id': 'sTPc_k2B_SqV',
        'taxonomy/preferred-label': 'Tyresö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Upplands-Bro',
        'taxonomy/id': 'w6yq_CGR_Fiv',
        'taxonomy/preferred-label': 'Upplands-Bro',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nykvarn',
        'taxonomy/id': 'mBKv_q3B_SK8',
        'taxonomy/preferred-label': 'Nykvarn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Täby',
        'taxonomy/id': 'onpA_B5a_zfv',
        'taxonomy/preferred-label': 'Täby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Danderyd',
        'taxonomy/id': 'E4CV_a5E_ucX',
        'taxonomy/preferred-label': 'Danderyd',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sollentuna',
        'taxonomy/id': 'Z5Cq_SgB_dsB',
        'taxonomy/preferred-label': 'Sollentuna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Stockholm',
        'taxonomy/id': 'AvNB_uwa_6n6',
        'taxonomy/preferred-label': 'Stockholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Södertälje',
        'taxonomy/id': 'g6hK_M1o_hiU',
        'taxonomy/preferred-label': 'Södertälje',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nacka',
        'taxonomy/id': 'aYA7_PpG_BqP',
        'taxonomy/preferred-label': 'Nacka',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sundbyberg',
        'taxonomy/id': 'UTJZ_zHH_mJm',
        'taxonomy/preferred-label': 'Sundbyberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Solna',
        'taxonomy/id': 'zHxw_uJZ_NJ8',
        'taxonomy/preferred-label': 'Solna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lidingö',
        'taxonomy/id': 'FBbF_mda_TYD',
        'taxonomy/preferred-label': 'Lidingö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vaxholm',
        'taxonomy/id': '9aAJ_j6L_DST',
        'taxonomy/preferred-label': 'Vaxholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Norrtälje',
        'taxonomy/id': 'btgf_fS7_sKG',
        'taxonomy/preferred-label': 'Norrtälje',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sigtuna',
        'taxonomy/id': '8ryy_X54_xJj',
        'taxonomy/preferred-label': 'Sigtuna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nynäshamn',
        'taxonomy/id': '37UU_T7x_oxG',
        'taxonomy/preferred-label': 'Nynäshamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Håbo',
        'taxonomy/id': 'Bbs5_JUs_Qh5',
        'taxonomy/preferred-label': 'Håbo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Älvkarleby',
        'taxonomy/id': 'cbyw_9aK_Cni',
        'taxonomy/preferred-label': 'Älvkarleby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Knivsta',
        'taxonomy/id': 'KALq_sG6_VrW',
        'taxonomy/preferred-label': 'Knivsta',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tierp',
        'taxonomy/id': 'K8A2_JBa_e6e',
        'taxonomy/preferred-label': 'Tierp',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Uppsala',
        'taxonomy/id': 'otaF_bQY_4ZD',
        'taxonomy/preferred-label': 'Uppsala',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Enköping',
        'taxonomy/id': 'HGwg_unG_TsG',
        'taxonomy/preferred-label': 'Enköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Östhammar',
        'taxonomy/id': 'VE3L_3Ei_XbG',
        'taxonomy/preferred-label': 'Östhammar',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vingåker',
        'taxonomy/id': 'rut9_f5W_kTX',
        'taxonomy/preferred-label': 'Vingåker',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gnesta',
        'taxonomy/id': 'os8Y_RUo_U3u',
        'taxonomy/preferred-label': 'Gnesta',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nyköping',
        'taxonomy/id': 'KzvD_ePV_DKQ',
        'taxonomy/preferred-label': 'Nyköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Oxelösund',
        'taxonomy/id': '72XK_mUU_CAH',
        'taxonomy/preferred-label': 'Oxelösund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Flen',
        'taxonomy/id': 'P8yp_WT9_Bks',
        'taxonomy/preferred-label': 'Flen',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Katrineholm',
        'taxonomy/id': 'snx9_qVD_Dr1',
        'taxonomy/preferred-label': 'Katrineholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Eskilstuna',
        'taxonomy/id': 'kMxr_NiX_YrU',
        'taxonomy/preferred-label': 'Eskilstuna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Strängnäs',
        'taxonomy/id': 'shnD_RiE_RKL',
        'taxonomy/preferred-label': 'Strängnäs',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Trosa',
        'taxonomy/id': 'rjzu_nQn_mCK',
        'taxonomy/preferred-label': 'Trosa',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ödeshög',
        'taxonomy/id': 'Fu8g_29u_3xF',
        'taxonomy/preferred-label': 'Ödeshög',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ydre',
        'taxonomy/id': 'vRRz_nLT_vYv',
        'taxonomy/preferred-label': 'Ydre',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kinda',
        'taxonomy/id': 'U4XJ_hYF_FBA',
        'taxonomy/preferred-label': 'Kinda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Boxholm',
        'taxonomy/id': 'e5LB_m9V_TnT',
        'taxonomy/preferred-label': 'Boxholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Åtvidaberg',
        'taxonomy/id': 'bFWo_FRJ_x2T',
        'taxonomy/preferred-label': 'Åtvidaberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Finspång',
        'taxonomy/id': 'dMFe_J6W_iJv',
        'taxonomy/preferred-label': 'Finspång',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Valdemarsvik',
        'taxonomy/id': 'Sb3D_iGB_aXu',
        'taxonomy/preferred-label': 'Valdemarsvik',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Linköping',
        'taxonomy/id': 'bm2x_1mr_Qhx',
        'taxonomy/preferred-label': 'Linköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Norrköping',
        'taxonomy/id': 'SYty_Yho_JAF',
        'taxonomy/preferred-label': 'Norrköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Söderköping',
        'taxonomy/id': 'Pcv9_yYh_Uw8',
        'taxonomy/preferred-label': 'Söderköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Motala',
        'taxonomy/id': 'E1MC_1uG_phm',
        'taxonomy/preferred-label': 'Motala',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vadstena',
        'taxonomy/id': 'VcCU_Y86_eKU',
        'taxonomy/preferred-label': 'Vadstena',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mjölby',
        'taxonomy/id': 'stqv_JGB_x8A',
        'taxonomy/preferred-label': 'Mjölby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lekeberg',
        'taxonomy/id': 'yaHU_E7z_YnE',
        'taxonomy/preferred-label': 'Lekeberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Laxå',
        'taxonomy/id': 'oYEQ_m8Q_unY',
        'taxonomy/preferred-label': 'Laxå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hallsberg',
        'taxonomy/id': 'Ak9V_rby_yYS',
        'taxonomy/preferred-label': 'Hallsberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Degerfors',
        'taxonomy/id': 'pvzC_muj_rcq',
        'taxonomy/preferred-label': 'Degerfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hällefors',
        'taxonomy/id': 'sCbY_r36_xhs',
        'taxonomy/preferred-label': 'Hällefors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ljusnarsberg',
        'taxonomy/id': 'eF2n_714_hSU',
        'taxonomy/preferred-label': 'Ljusnarsberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Örebro',
        'taxonomy/id': 'kuMn_feU_hXx',
        'taxonomy/preferred-label': 'Örebro',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kumla',
        'taxonomy/id': 'viCA_36P_pQp',
        'taxonomy/preferred-label': 'Kumla',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Askersund',
        'taxonomy/id': 'dbF7_Ecz_CWF',
        'taxonomy/preferred-label': 'Askersund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Karlskoga',
        'taxonomy/id': 'wgJm_upX_z5W',
        'taxonomy/preferred-label': 'Karlskoga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nora',
        'taxonomy/id': 'WFXN_hsU_gmx',
        'taxonomy/preferred-label': 'Nora',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lindesberg',
        'taxonomy/id': 'JQE9_189_Ska',
        'taxonomy/preferred-label': 'Lindesberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skinnskatteberg',
        'taxonomy/id': 'Nufj_vmt_VrH',
        'taxonomy/preferred-label': 'Skinnskatteberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Surahammar',
        'taxonomy/id': 'jfD3_Hdg_UhT',
        'taxonomy/preferred-label': 'Surahammar',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Heby',
        'taxonomy/id': 'sD2e_1Tr_4WZ',
        'taxonomy/preferred-label': 'Heby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kungsör',
        'taxonomy/id': 'Fac5_h7a_UoM',
        'taxonomy/preferred-label': 'Kungsör',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hallstahammar',
        'taxonomy/id': 'oXYf_HmD_ddE',
        'taxonomy/preferred-label': 'Hallstahammar',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Norberg',
        'taxonomy/id': 'jbVe_Cps_vtd',
        'taxonomy/preferred-label': 'Norberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Västerås',
        'taxonomy/id': '8deT_FRF_2SP',
        'taxonomy/preferred-label': 'Västerås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sala',
        'taxonomy/id': 'dAen_yTK_tqz',
        'taxonomy/preferred-label': 'Sala',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Fagersta',
        'taxonomy/id': '7D9G_yrX_AGJ',
        'taxonomy/preferred-label': 'Fagersta',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Köping',
        'taxonomy/id': '4Taz_AuG_tSm',
        'taxonomy/preferred-label': 'Köping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Arboga',
        'taxonomy/id': 'Jkyb_5MQ_7pB',
        'taxonomy/preferred-label': 'Arboga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Olofström',
        'taxonomy/id': '1gEC_kvM_TXK',
        'taxonomy/preferred-label': 'Olofström',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Karlskrona',
        'taxonomy/id': 'YSt4_bAa_ccs',
        'taxonomy/preferred-label': 'Karlskrona',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ronneby',
        'taxonomy/id': 'vH8x_gVz_z7R',
        'taxonomy/preferred-label': 'Ronneby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Karlshamn',
        'taxonomy/id': 'HtGW_WgR_dpE',
        'taxonomy/preferred-label': 'Karlshamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sölvesborg',
        'taxonomy/id': 'EVPy_phD_8Vf',
        'taxonomy/preferred-label': 'Sölvesborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Svalöv',
        'taxonomy/id': '2r6J_g2w_qp5',
        'taxonomy/preferred-label': 'Svalöv',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Staffanstorp',
        'taxonomy/id': 'vBrj_bov_KEX',
        'taxonomy/preferred-label': 'Staffanstorp',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Burlöv',
        'taxonomy/id': '64g5_Lio_aMU',
        'taxonomy/preferred-label': 'Burlöv',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vellinge',
        'taxonomy/id': 'Tcog_5sH_b46',
        'taxonomy/preferred-label': 'Vellinge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Östra Göinge',
        'taxonomy/id': 'LTt7_CGG_RUf',
        'taxonomy/preferred-label': 'Östra Göinge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Örkelljunga',
        'taxonomy/id': 'nBTS_Nge_dVH',
        'taxonomy/preferred-label': 'Örkelljunga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bjuv',
        'taxonomy/id': 'waQp_FjW_qhF',
        'taxonomy/preferred-label': 'Bjuv',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kävlinge',
        'taxonomy/id': '5ohg_WJU_Ktn',
        'taxonomy/preferred-label': 'Kävlinge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lomma',
        'taxonomy/id': 'naG4_AUS_z2v',
        'taxonomy/preferred-label': 'Lomma',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Svedala',
        'taxonomy/id': 'n6r4_fjK_kRr',
        'taxonomy/preferred-label': 'Svedala',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skurup',
        'taxonomy/id': 'oezL_78x_r89',
        'taxonomy/preferred-label': 'Skurup',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sjöbo',
        'taxonomy/id': 'P3Cs_1ZP_9XB',
        'taxonomy/preferred-label': 'Sjöbo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hörby',
        'taxonomy/id': 'autr_KMa_cfp',
        'taxonomy/preferred-label': 'Hörby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Höör',
        'taxonomy/id': 'N29z_AqQ_Ppc',
        'taxonomy/preferred-label': 'Höör',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tomelilla',
        'taxonomy/id': 'UMev_wGs_9bg',
        'taxonomy/preferred-label': 'Tomelilla',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bromölla',
        'taxonomy/id': 'WMNK_PXa_Khm',
        'taxonomy/preferred-label': 'Bromölla',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Osby',
        'taxonomy/id': 'najS_Lvy_mDD',
        'taxonomy/preferred-label': 'Osby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Perstorp',
        'taxonomy/id': 'BN7r_iPV_F9p',
        'taxonomy/preferred-label': 'Perstorp',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Klippan',
        'taxonomy/id': 'JARU_FAY_hTS',
        'taxonomy/preferred-label': 'Klippan',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Åstorp',
        'taxonomy/id': 'tEv6_ktG_QQb',
        'taxonomy/preferred-label': 'Åstorp',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Båstad',
        'taxonomy/id': 'i8vK_odq_6ar',
        'taxonomy/preferred-label': 'Båstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Malmö',
        'taxonomy/id': 'oYPt_yRA_Smm',
        'taxonomy/preferred-label': 'Malmö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lund',
        'taxonomy/id': 'muSY_tsR_vDZ',
        'taxonomy/preferred-label': 'Lund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Landskrona',
        'taxonomy/id': 'Yt5s_Vf9_rds',
        'taxonomy/preferred-label': 'Landskrona',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Helsingborg',
        'taxonomy/id': 'qj3q_oXH_MGR',
        'taxonomy/preferred-label': 'Helsingborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Höganäs',
        'taxonomy/id': '8QQ6_e95_a1d',
        'taxonomy/preferred-label': 'Höganäs',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Eslöv',
        'taxonomy/id': 'gfCw_egj_1M4',
        'taxonomy/preferred-label': 'Eslöv',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ystad',
        'taxonomy/id': 'hdYk_hnP_uju',
        'taxonomy/preferred-label': 'Ystad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Trelleborg',
        'taxonomy/id': 'STvk_dra_M1X',
        'taxonomy/preferred-label': 'Trelleborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kristianstad',
        'taxonomy/id': 'vrvW_sr8_1en',
        'taxonomy/preferred-label': 'Kristianstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Simrishamn',
        'taxonomy/id': 'dLxo_EpC_oPe',
        'taxonomy/preferred-label': 'Simrishamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ängelholm',
        'taxonomy/id': 'pCuv_P5A_9oh',
        'taxonomy/preferred-label': 'Ängelholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hässleholm',
        'taxonomy/id': 'bP5q_53x_aqJ',
        'taxonomy/preferred-label': 'Hässleholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kil',
        'taxonomy/id': 'ocMw_Rz5_B1L',
        'taxonomy/preferred-label': 'Kil',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Eda',
        'taxonomy/id': 'N5HQ_hfp_7Rm',
        'taxonomy/preferred-label': 'Eda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Torsby',
        'taxonomy/id': 'hQdb_zn9_Sok',
        'taxonomy/preferred-label': 'Torsby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Storfors',
        'taxonomy/id': 'mPt5_3QD_LTM',
        'taxonomy/preferred-label': 'Storfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hammarö',
        'taxonomy/id': 'x5qW_BXr_aut',
        'taxonomy/preferred-label': 'Hammarö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Munkfors',
        'taxonomy/id': 'x73h_7rW_mXN',
        'taxonomy/preferred-label': 'Munkfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Forshaga',
        'taxonomy/id': 'xnEt_JN3_GkA',
        'taxonomy/preferred-label': 'Forshaga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Grums',
        'taxonomy/id': 'PSNt_P95_x6q',
        'taxonomy/preferred-label': 'Grums',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Årjäng',
        'taxonomy/id': 'ymBu_aFc_QJA',
        'taxonomy/preferred-label': 'Årjäng',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sunne',
        'taxonomy/id': 'oqNH_cnJ_Tdi',
        'taxonomy/preferred-label': 'Sunne',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Karlstad',
        'taxonomy/id': 'hRDj_PoV_sFU',
        'taxonomy/preferred-label': 'Karlstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kristinehamn',
        'taxonomy/id': 'SVQS_uwJ_m2B',
        'taxonomy/preferred-label': 'Kristinehamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Filipstad',
        'taxonomy/id': 'UXir_vKD_FuW',
        'taxonomy/preferred-label': 'Filipstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hagfors',
        'taxonomy/id': 'qk9a_g5U_sAH',
        'taxonomy/preferred-label': 'Hagfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Arvika',
        'taxonomy/id': 'yGue_F32_wev',
        'taxonomy/preferred-label': 'Arvika',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Säffle',
        'taxonomy/id': 'wmxQ_Guc_dsy',
        'taxonomy/preferred-label': 'Säffle',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vansbro',
        'taxonomy/id': '4eS9_HX1_M7V',
        'taxonomy/preferred-label': 'Vansbro',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Malung-Sälen',
        'taxonomy/id': 'FPCd_poj_3tq',
        'taxonomy/preferred-label': 'Malung-Sälen',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gagnef',
        'taxonomy/id': 'Nn7p_W3Z_y68',
        'taxonomy/preferred-label': 'Gagnef',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Leksand',
        'taxonomy/id': '7Zsu_ant_gcn',
        'taxonomy/preferred-label': 'Leksand',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Rättvik',
        'taxonomy/id': 'Jy3D_2ux_dg8',
        'taxonomy/preferred-label': 'Rättvik',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Orsa',
        'taxonomy/id': 'CRyF_5Jg_4ht',
        'taxonomy/preferred-label': 'Orsa',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Älvdalen',
        'taxonomy/id': 'cZtt_qGo_oBr',
        'taxonomy/preferred-label': 'Älvdalen',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Smedjebacken',
        'taxonomy/id': '5zZX_8FH_Sbq',
        'taxonomy/preferred-label': 'Smedjebacken',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mora',
        'taxonomy/id': 'UGcC_kYx_fTs',
        'taxonomy/preferred-label': 'Mora',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Falun',
        'taxonomy/id': 'N1wJ_Cuu_7Cs',
        'taxonomy/preferred-label': 'Falun',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Borlänge',
        'taxonomy/id': 'cpya_jJg_pGp',
        'taxonomy/preferred-label': 'Borlänge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Säter',
        'taxonomy/id': 'c3Zx_jBf_CqF',
        'taxonomy/preferred-label': 'Säter',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hedemora',
        'taxonomy/id': 'DE9u_V4K_Z1S',
        'taxonomy/preferred-label': 'Hedemora',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Avesta',
        'taxonomy/id': 'Szbq_2fg_ydQ',
        'taxonomy/preferred-label': 'Avesta',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ludvika',
        'taxonomy/id': 'Ny2b_2bo_7EL',
        'taxonomy/preferred-label': 'Ludvika',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ockelbo',
        'taxonomy/id': 'GEvW_wKy_A9H',
        'taxonomy/preferred-label': 'Ockelbo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hofors',
        'taxonomy/id': 'yuNd_3bg_ttc',
        'taxonomy/preferred-label': 'Hofors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ovanåker',
        'taxonomy/id': 'JPSe_mUQ_NDs',
        'taxonomy/preferred-label': 'Ovanåker',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nordanstig',
        'taxonomy/id': 'fFeF_RCz_Tm5',
        'taxonomy/preferred-label': 'Nordanstig',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ljusdal',
        'taxonomy/id': '63iQ_V6F_REB',
        'taxonomy/preferred-label': 'Ljusdal',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gävle',
        'taxonomy/id': 'qk8Y_2b6_82D',
        'taxonomy/preferred-label': 'Gävle',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sandviken',
        'taxonomy/id': 'BbdN_xLB_k6s',
        'taxonomy/preferred-label': 'Sandviken',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Söderhamn',
        'taxonomy/id': 'JauG_nz5_7mu',
        'taxonomy/preferred-label': 'Söderhamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bollnäs',
        'taxonomy/id': 'KxjG_ig5_exF',
        'taxonomy/preferred-label': 'Bollnäs',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hudiksvall',
        'taxonomy/id': 'Utks_mwF_axY',
        'taxonomy/preferred-label': 'Hudiksvall',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ånge',
        'taxonomy/id': 'swVa_cyS_EMN',
        'taxonomy/preferred-label': 'Ånge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Timrå',
        'taxonomy/id': 'oJ8D_rq6_kjt',
        'taxonomy/preferred-label': 'Timrå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Härnösand',
        'taxonomy/id': 'uYRx_AdM_r4A',
        'taxonomy/preferred-label': 'Härnösand',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sundsvall',
        'taxonomy/id': 'dJbx_FWY_tK6',
        'taxonomy/preferred-label': 'Sundsvall',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kramfors',
        'taxonomy/id': 'yR8g_7Jz_HBZ',
        'taxonomy/preferred-label': 'Kramfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sollefteå',
        'taxonomy/id': 'v5y4_YPe_TMZ',
        'taxonomy/preferred-label': 'Sollefteå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Örnsköldsvik',
        'taxonomy/id': 'zBmE_n6s_MnQ',
        'taxonomy/preferred-label': 'Örnsköldsvik',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ragunda',
        'taxonomy/id': 'Voto_egJ_FZP',
        'taxonomy/preferred-label': 'Ragunda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bräcke',
        'taxonomy/id': 'eNSc_Nj1_CDP',
        'taxonomy/preferred-label': 'Bräcke',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Krokom',
        'taxonomy/id': 'yurW_aLE_4ga',
        'taxonomy/preferred-label': 'Krokom',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Strömsund',
        'taxonomy/id': 'ppjq_Eci_Wz9',
        'taxonomy/preferred-label': 'Strömsund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Åre',
        'taxonomy/id': 'D7ax_CXP_6r1',
        'taxonomy/preferred-label': 'Åre',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Berg',
        'taxonomy/id': 'gRNJ_hVW_Gpg',
        'taxonomy/preferred-label': 'Berg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Härjedalen',
        'taxonomy/id': 'j35Q_VKL_NiM',
        'taxonomy/preferred-label': 'Härjedalen',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Östersund',
        'taxonomy/id': 'Vt7P_856_WZS',
        'taxonomy/preferred-label': 'Östersund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nordmaling',
        'taxonomy/id': 'wMab_4Zs_wpM',
        'taxonomy/preferred-label': 'Nordmaling',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bjurholm',
        'taxonomy/id': 'vQkf_tw2_CmR',
        'taxonomy/preferred-label': 'Bjurholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vindeln',
        'taxonomy/id': 'izT6_zWu_tta',
        'taxonomy/preferred-label': 'Vindeln',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Robertsfors',
        'taxonomy/id': 'p8Mv_377_bxp',
        'taxonomy/preferred-label': 'Robertsfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Norsjö',
        'taxonomy/id': 'XmpG_vPQ_K7T',
        'taxonomy/preferred-label': 'Norsjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Malå',
        'taxonomy/id': '7sHJ_YCE_5Zv',
        'taxonomy/preferred-label': 'Malå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Storuman',
        'taxonomy/id': 'gQgT_BAk_fMu',
        'taxonomy/preferred-label': 'Storuman',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sorsele',
        'taxonomy/id': 'VM7L_yJK_Doo',
        'taxonomy/preferred-label': 'Sorsele',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Dorotea',
        'taxonomy/id': 'tSkf_Tbn_rHk',
        'taxonomy/preferred-label': 'Dorotea',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vännäs',
        'taxonomy/id': 'utQc_6xq_Dfm',
        'taxonomy/preferred-label': 'Vännäs',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vilhelmina',
        'taxonomy/id': 'tUnW_mFo_Hvi',
        'taxonomy/preferred-label': 'Vilhelmina',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Åsele',
        'taxonomy/id': 'xLdL_tMA_JJv',
        'taxonomy/preferred-label': 'Åsele',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Umeå',
        'taxonomy/id': 'QiGt_BLu_amP',
        'taxonomy/preferred-label': 'Umeå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lycksele',
        'taxonomy/id': '7rpN_naz_3Uz',
        'taxonomy/preferred-label': 'Lycksele',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skellefteå',
        'taxonomy/id': 'kicB_LgH_2Dk',
        'taxonomy/preferred-label': 'Skellefteå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Arvidsjaur',
        'taxonomy/id': 'A5WX_XVo_Zt6',
        'taxonomy/preferred-label': 'Arvidsjaur',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Arjeplog',
        'taxonomy/id': 'vkQW_GB6_MNk',
        'taxonomy/preferred-label': 'Arjeplog',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Jokkmokk',
        'taxonomy/id': 'mp6j_2b6_1bz',
        'taxonomy/preferred-label': 'Jokkmokk',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Överkalix',
        'taxonomy/id': 'n5Sq_xxo_QWL',
        'taxonomy/preferred-label': 'Överkalix',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kalix',
        'taxonomy/id': 'cUyN_C9V_HLU',
        'taxonomy/preferred-label': 'Kalix',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Övertorneå',
        'taxonomy/id': 'ehMP_onv_Chk',
        'taxonomy/preferred-label': 'Övertorneå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Pajala',
        'taxonomy/id': 'dHMF_72G_4NM',
        'taxonomy/preferred-label': 'Pajala',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gällivare',
        'taxonomy/id': '6R2u_zkb_uoS',
        'taxonomy/preferred-label': 'Gällivare',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Älvsbyn',
        'taxonomy/id': '14WF_zh1_W3y',
        'taxonomy/preferred-label': 'Älvsbyn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Luleå',
        'taxonomy/id': 'CXbY_gui_14v',
        'taxonomy/preferred-label': 'Luleå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Piteå',
        'taxonomy/id': 'umej_bP2_PpK',
        'taxonomy/preferred-label': 'Piteå',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Boden',
        'taxonomy/id': 'y4NQ_tnB_eVd',
        'taxonomy/preferred-label': 'Boden',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Haparanda',
        'taxonomy/id': 'tfRE_hXa_eq7',
        'taxonomy/preferred-label': 'Haparanda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kiruna',
        'taxonomy/id': 'biN6_UiL_Qob',
        'taxonomy/preferred-label': 'Kiruna',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Aneby',
        'taxonomy/id': 'y9HE_XD7_WaD',
        'taxonomy/preferred-label': 'Aneby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gnosjö',
        'taxonomy/id': '91VR_Hxi_GN4',
        'taxonomy/preferred-label': 'Gnosjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mullsjö',
        'taxonomy/id': 'smXg_BXp_jTW',
        'taxonomy/preferred-label': 'Mullsjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Habo',
        'taxonomy/id': '9zQB_3vU_BQA',
        'taxonomy/preferred-label': 'Habo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gislaved',
        'taxonomy/id': 'cNQx_Yqi_83Q',
        'taxonomy/preferred-label': 'Gislaved',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vaggeryd',
        'taxonomy/id': 'zFup_umX_LVv',
        'taxonomy/preferred-label': 'Vaggeryd',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Jönköping',
        'taxonomy/id': 'KURg_KJF_Lwc',
        'taxonomy/preferred-label': 'Jönköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nässjö',
        'taxonomy/id': 'KfXT_ySA_do2',
        'taxonomy/preferred-label': 'Nässjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Värnamo',
        'taxonomy/id': '6bS8_fzf_xpW',
        'taxonomy/preferred-label': 'Värnamo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sävsjö',
        'taxonomy/id': 'L1cX_MjM_y8W',
        'taxonomy/preferred-label': 'Sävsjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vetlanda',
        'taxonomy/id': 'xJqx_SLC_415',
        'taxonomy/preferred-label': 'Vetlanda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Eksjö',
        'taxonomy/id': 'VacK_WF6_XVg',
        'taxonomy/preferred-label': 'Eksjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tranås',
        'taxonomy/id': 'Namm_SpC_RPG',
        'taxonomy/preferred-label': 'Tranås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Uppvidinge',
        'taxonomy/id': '78cu_S5T_Pgp',
        'taxonomy/preferred-label': 'Uppvidinge',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lessebo',
        'taxonomy/id': 'nXZy_1Jd_D8X',
        'taxonomy/preferred-label': 'Lessebo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tingsryd',
        'taxonomy/id': 'qz8Q_kDz_N2Y',
        'taxonomy/preferred-label': 'Tingsryd',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Alvesta',
        'taxonomy/id': 'MMph_wmN_esc',
        'taxonomy/preferred-label': 'Alvesta',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Älmhult',
        'taxonomy/id': 'EK6X_wZq_CQ8',
        'taxonomy/preferred-label': 'Älmhult',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Markaryd',
        'taxonomy/id': 'ZhVf_yL5_Q5g',
        'taxonomy/preferred-label': 'Markaryd',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Växjö',
        'taxonomy/id': 'mmot_H3A_auW',
        'taxonomy/preferred-label': 'Växjö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ljungby',
        'taxonomy/id': 'GzKo_S48_QCm',
        'taxonomy/preferred-label': 'Ljungby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Högsby',
        'taxonomy/id': 'WPDh_pMr_RLZ',
        'taxonomy/preferred-label': 'Högsby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Torsås',
        'taxonomy/id': 'wYFb_q7w_Nnh',
        'taxonomy/preferred-label': 'Torsås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mörbylånga',
        'taxonomy/id': 'Muim_EAi_EFp',
        'taxonomy/preferred-label': 'Mörbylånga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hultsfred',
        'taxonomy/id': 'AEQD_1RT_vM9',
        'taxonomy/preferred-label': 'Hultsfred',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mönsterås',
        'taxonomy/id': '8eEp_iz4_cNN',
        'taxonomy/preferred-label': 'Mönsterås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Emmaboda',
        'taxonomy/id': '1koj_6Bg_8K6',
        'taxonomy/preferred-label': 'Emmaboda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kalmar',
        'taxonomy/id': 'Pnmg_SgP_uHQ',
        'taxonomy/preferred-label': 'Kalmar',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Nybro',
        'taxonomy/id': 'xk68_bJa_6Fh',
        'taxonomy/preferred-label': 'Nybro',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Oskarshamn',
        'taxonomy/id': 'tUP8_hRE_NcF',
        'taxonomy/preferred-label': 'Oskarshamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Västervik',
        'taxonomy/id': 't7H4_S2P_3Fw',
        'taxonomy/preferred-label': 'Västervik',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vimmerby',
        'taxonomy/id': 'a7hJ_zwv_2FR',
        'taxonomy/preferred-label': 'Vimmerby',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Borgholm',
        'taxonomy/id': 'LY9i_qNL_kXf',
        'taxonomy/preferred-label': 'Borgholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gotland',
        'taxonomy/id': 'Ft9P_E8F_VLJ',
        'taxonomy/preferred-label': 'Gotland',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hylte',
        'taxonomy/id': '3XMe_nGt_RcU',
        'taxonomy/preferred-label': 'Hylte',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Halmstad',
        'taxonomy/id': 'kUQB_KdK_kAh',
        'taxonomy/preferred-label': 'Halmstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Laholm',
        'taxonomy/id': 'c1iL_rqh_Zja',
        'taxonomy/preferred-label': 'Laholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Falkenberg',
        'taxonomy/id': 'qaJg_wMR_C8T',
        'taxonomy/preferred-label': 'Falkenberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Varberg',
        'taxonomy/id': 'AkUx_yAq_kGr',
        'taxonomy/preferred-label': 'Varberg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kungsbacka',
        'taxonomy/id': '3JKV_KSK_x6z',
        'taxonomy/preferred-label': 'Kungsbacka',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Härryda',
        'taxonomy/id': 'dzWW_R3G_6Eh',
        'taxonomy/preferred-label': 'Härryda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Partille',
        'taxonomy/id': 'CCiR_sXa_BVW',
        'taxonomy/preferred-label': 'Partille',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Öckerö',
        'taxonomy/id': 'Zjiv_rhk_oJK',
        'taxonomy/preferred-label': 'Öckerö',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Stenungsund',
        'taxonomy/id': 'wHrG_FBH_hoD',
        'taxonomy/preferred-label': 'Stenungsund',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tjörn',
        'taxonomy/id': 'TbL3_HmF_gnx',
        'taxonomy/preferred-label': 'Tjörn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Orust',
        'taxonomy/id': 'tmAp_ykH_N6k',
        'taxonomy/preferred-label': 'Orust',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Sotenäs',
        'taxonomy/id': 'aKkp_sEX_cVM',
        'taxonomy/preferred-label': 'Sotenäs',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Munkedal',
        'taxonomy/id': '96Dh_3sQ_RFb',
        'taxonomy/preferred-label': 'Munkedal',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tanum',
        'taxonomy/id': 'qffn_qY4_DLk',
        'taxonomy/preferred-label': 'Tanum',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Dals-Ed',
        'taxonomy/id': 'NMc9_oEm_yxy',
        'taxonomy/preferred-label': 'Dals-Ed',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Färgelanda',
        'taxonomy/id': 'kCHb_icw_W5E',
        'taxonomy/preferred-label': 'Färgelanda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ale',
        'taxonomy/id': '17Ug_Btv_mBr',
        'taxonomy/preferred-label': 'Ale',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lerum',
        'taxonomy/id': 'yHV7_2Y6_zQx',
        'taxonomy/preferred-label': 'Lerum',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vårgårda',
        'taxonomy/id': 'NfFx_5jj_ogg',
        'taxonomy/preferred-label': 'Vårgårda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bollebygd',
        'taxonomy/id': 'ypAQ_vTD_KLU',
        'taxonomy/preferred-label': 'Bollebygd',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Grästorp',
        'taxonomy/id': 'ZNZy_Hh5_gSW',
        'taxonomy/preferred-label': 'Grästorp',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Essunga',
        'taxonomy/id': 'ZzEA_2Fg_Pt2',
        'taxonomy/preferred-label': 'Essunga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Karlsborg',
        'taxonomy/id': 'e413_94L_hdh',
        'taxonomy/preferred-label': 'Karlsborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Gullspång',
        'taxonomy/id': 'roiB_uVV_4Cj',
        'taxonomy/preferred-label': 'Gullspång',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tranemo',
        'taxonomy/id': 'SEje_LdC_9qN',
        'taxonomy/preferred-label': 'Tranemo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Bengtsfors',
        'taxonomy/id': 'hejM_Jct_XJk',
        'taxonomy/preferred-label': 'Bengtsfors',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mellerud',
        'taxonomy/id': 'tt1B_7rH_vhG',
        'taxonomy/preferred-label': 'Mellerud',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lilla Edet',
        'taxonomy/id': 'YQcE_SNB_Tv3',
        'taxonomy/preferred-label': 'Lilla Edet',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mark',
        'taxonomy/id': '7HAb_9or_eFM',
        'taxonomy/preferred-label': 'Mark',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Svenljunga',
        'taxonomy/id': 'rZWC_pXf_ySZ',
        'taxonomy/preferred-label': 'Svenljunga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Herrljunga',
        'taxonomy/id': 'J116_VFs_cg6',
        'taxonomy/preferred-label': 'Herrljunga',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vara',
        'taxonomy/id': 'fbHM_yhA_BqS',
        'taxonomy/preferred-label': 'Vara',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Götene',
        'taxonomy/id': 'txzq_PQY_FGi',
        'taxonomy/preferred-label': 'Götene',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tibro',
        'taxonomy/id': 'aLFZ_NHw_atB',
        'taxonomy/preferred-label': 'Tibro',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Töreboda',
        'taxonomy/id': 'a15F_gAH_pn6',
        'taxonomy/preferred-label': 'Töreboda',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Göteborg',
        'taxonomy/id': 'PVZL_BQT_XtL',
        'taxonomy/preferred-label': 'Göteborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mölndal',
        'taxonomy/id': 'mc45_ki9_Bv3',
        'taxonomy/preferred-label': 'Mölndal',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Kungälv',
        'taxonomy/id': 'ZkZf_HbK_Mcr',
        'taxonomy/preferred-label': 'Kungälv',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lysekil',
        'taxonomy/id': 'z2cX_rjC_zFo',
        'taxonomy/preferred-label': 'Lysekil',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Uddevalla',
        'taxonomy/id': 'xQc2_SzA_rHK',
        'taxonomy/preferred-label': 'Uddevalla',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Strömstad',
        'taxonomy/id': 'PAxT_FLT_3Kq',
        'taxonomy/preferred-label': 'Strömstad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Vänersborg',
        'taxonomy/id': 'THif_q6H_MjG',
        'taxonomy/preferred-label': 'Vänersborg',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Trollhättan',
        'taxonomy/id': 'CSy8_41F_YvX',
        'taxonomy/preferred-label': 'Trollhättan',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Alingsås',
        'taxonomy/id': 'UQ75_1eU_jaC',
        'taxonomy/preferred-label': 'Alingsås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Borås',
        'taxonomy/id': 'TpRZ_bFL_jhL',
        'taxonomy/preferred-label': 'Borås',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Ulricehamn',
        'taxonomy/id': 'an4a_8t2_Zpd',
        'taxonomy/preferred-label': 'Ulricehamn',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Åmål',
        'taxonomy/id': 'M1UC_Cnf_r7g',
        'taxonomy/preferred-label': 'Åmål',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Mariestad',
        'taxonomy/id': 'Lzpu_thX_Wpa',
        'taxonomy/preferred-label': 'Mariestad',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Lidköping',
        'taxonomy/id': 'FN1Y_asc_D8y',
        'taxonomy/preferred-label': 'Lidköping',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skara',
        'taxonomy/id': 'k1SK_gxg_dW4',
        'taxonomy/preferred-label': 'Skara',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skövde',
        'taxonomy/id': 'fqAy_4ji_Lz2',
        'taxonomy/preferred-label': 'Skövde',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Hjo',
        'taxonomy/id': 'YbFS_34r_K2v',
        'taxonomy/preferred-label': 'Hjo',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Tidaholm',
        'taxonomy/id': 'Zsf5_vpP_Bs4',
        'taxonomy/preferred-label': 'Tidaholm',
      },
      {
        'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Falköping',
        'taxonomy/id': 'ZySF_gif_zE4',
        'taxonomy/preferred-label': 'Falköping',
      },
    ],
  }),
  methods: {
    ...mapActions([
      'setJobStatus',
      'updateJobAdById',
      'retrieveJobAdById',
      'retrieveUserProfile',
      'retrieveJobActivities',
      'retrieveJobAdCommentsList',
      'retrieveCitiesListByCountryId',
      'retrieveActivitiesForJob',
      'retrieveCompetencesList',
      'retrieveJobComments',
      'addJobAdComment',
      'editJobAdComment',
      'removeJobAdComment',
      'sendManagerRecent',
      'retrieveEmployersDropdown',
      'retrieveSourcesList',
    ]),

    sanitizeDescription(html) {
      const allowed = ['strong', 'em', 'u', 'ul', 'li', 'p'];

      return html.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (match, tag) => {
        return allowed.includes(tag.toLowerCase()) ? match : '';
      });
    },

    copyOriginal() {
      this.plats_advertising.description = this.sanitizeDescription(this.selectedDescription);
    },
    formatPrice(value) {
      const str = String(value).replace(',', '.');
      let num = parseFloat(str);
      if (isNaN(num)) return '';
      num = Math.round(num);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    addProfession() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/platsbanken/createprofession`,
          {
            code: this.professionId,
            name: this.professionName,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeAddProfession.click();
          this.resetModal();
          this.getAllProfession();
          this.$toasted.success('New profession created.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllProfession() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/admin/platsbanken/professions`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.allProfessions = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllSkills() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/admin/platsbanken/skills`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.platsbankenSkills = res.data;
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },

    convertTime(time) {
      const tz = this.getUserProfile.timezone;
      const userFormat = this.getUserProfile.format_date;

      const formatMap = {
        'YY-MM-DD': 'YY-MM-DD HH:mm',
        'YY/MM/DD': 'YY/MM/DD HH:mm',
        'DD-MM-YY': 'DD-MM-YY HH:mm',
        'DD/MM/YY': 'DD/MM/YY HH:mm',
        'MM-DD-YY': 'MM-DD-YY HH:mm',
        'MM/DD/YY': 'MM/DD/YY HH:mm',
      };

      const fmt = formatMap[userFormat] || 'YYYY-MM-DD';

      // Get the first date, add '12:00', then parse according to user format and timezone
      const selectedDate = time; // e.g. "24-06-25" if DD-MM-YY
      const dateWithTime = `${selectedDate} 12:00`;

      return moment.tz(dateWithTime, fmt, tz).format('YYYY-MM-DD');
    },

    sentToPlats(status) {
      if (!this.selectedPostalCode || this.selectedPostalCode.length === 0) {
        this.$toasted.error('Please enter a postal code for the job', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }
      this.isPublishing = true;
      if (status === 'active') {
        setTimeout(() => {
          axios
            .post(
              `${process.env.VUE_APP_API_URL}/admin/platsbanken/publishjob`,
              {
                js_employer_jobad_id: this.$route.params.job_uuid,
                end_date: this.convertTime(this.plats_advertising.endDate),
                job_title: this.plats_advertising.title,
                occupation_code: this.plats_advertising.professionId.code,
                tracking_code: this.plats_advertising.tracking,
                /*  */
                description: this.sanitizeDescription(this.plats_advertising.description),
                municipality: this.plats_advertising.manu['taxonomy/preferred-label'],
                municipality_code: this.plats_advertising.manu['taxonomy/id'],
                skills: (this.plats_advertising.skills || []).map(skill =>
                  typeof skill === 'object' ? skill.code : skill,
                ),
                wage_type: this.plats_advertising.wage,
                duration: this.plats_advertising.duration,
                worktime_extent: this.plats_advertising.worktime,
                experience: this.plats_advertising.experience,
                status: status,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                  )}`,
                },
              },
            )
            .then(res => {
              this.isPublishing = false;
              const message =
                status === 'inactive'
                  ? 'The job is no longer promoted at Platsbanken'
                  : 'The job was successfully published on Platsbanken';

              this.$refs.closePublishTo.click();
              this.$refs.closePublishToStop.click();
              this.$toasted.success(message, {
                theme: 'bubble',
                icon: 'fa-unlock-alt',
                position: 'bottom-right',
                duration: 5000,
              });
              this.testjson = res.data;
              this.getJobAd();
            })
            .catch(() => {
              this.isPublishing = false;
              this.$toasted.error('Could not transfer the information to Platsbanken', {
                theme: 'bubble',
                icon: 'fa-unlock-alt',
                position: 'bottom-right',
                duration: 5000,
              });
            });
        }, 2000);
      } else {
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/admin/platsbanken/remove`,
            {
              platsbanken_id: this.plats_advertising.platsbanken_id,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                )}`,
              },
            },
          )
          .then(res => {
            this.isPublishing = false;
            const message = 'The job is no longer promoted at Platsbanken';

            this.$refs.closePublishTo.click();
            this.$refs.closePublishToStop.click();
            this.$toasted.success(message, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
            this.getJobAd();
          })
          .catch(() => {
            this.isPublishing = false;
          });
      }
    },

    savePlats() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/platsbanken/update`,
          {
            platsbanken_id: this.plats_advertising.platsbanken_id,
            url: this.plats_advertising.link,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$toasted.success('The data was saved', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error('The data could not be saved', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    resetModal() {
      this.professionId = '';
      this.professionName = '';
      this.$refs.closeAddProfession.click();
    },
    seenProfile() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/admin/recentseen/store`,
        {
          jobad_id: this.$route.params.job_uuid,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },
    loadMoreActivities() {
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.retrieveActivitiesForJob({
          jobad_id: this.$route.params.job_uuid,
          count: this.pageCount,
          page: this.currentPage,
        }).then(() => {
          this.currentActivities = [
            ...this.currentActivities,
            ...Object.values(this.getActivitiesForJob.data),
          ];
        });
      }
    },
    onShowAdJobModal() {
      this.retrieveEmployersDropdown();
      this.showModal = true;
    },
    removeHtmlTags(adText, ...args) {
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;
      const removeInlineStyles = /style=["']?([a-zA-Z0-9 :\-#()._;',\s\n\r&]+);?["']?|<\s*font[^>]*>/g;

      return adText
        .replace(removeAllDivTags, '')
        .replace(removeInlineStyles, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    onEditText(desc) {
      this.selectedDescription = this.removeHtmlTags(desc, 'p');
      console.log(this.selectedDescription);
      this.editText = true;
    },
    getLocation(city, country) {
      if (city && country) {
        if (city.hasOwnProperty('name') && country.hasOwnProperty('name')) {
          return `${city.name}, ${country.name}`;
        }
      }
    },

    getEmploymentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.updateForm.reset();
    },
    clearCity() {
      this.selectedCity = '';
    },
    showEditForm(e) {
      if (e.target.id === 'currency') {
        this.editIconState.currencyFormShow = !this.editIconState.currencyFormShow;
      }
      if (e.target.id === 'stFee') {
        this.editIconState.startingFeeFormShow = !this.editIconState.startingFeeFormShow;
      }
      if (e.target.id === 'rFee') {
        this.editIconState.recruitingFeeFormShow = !this.editIconState.recruitingFeeFormShow;
      }
      if (e.target.id === 'prFee') {
        this.editIconState.proggramingTestFormShow = !this.editIconState.proggramingTestFormShow;
      }
      if (e.target.id === 'devskiller') {
        this.editIconState.devskillerFormShow = !this.editIconState.devskillerFormShow;
      }
      if (e.target.id === 'anon') {
        this.editIconState.anonFormShow = !this.editIconState.anonFormShow;
      }
      if (e.target.id === 'workplace') {
        this.editIconState.workplaceFormShow = !this.editIconState.workplaceFormShow;
      }
      if (e.target.id === 'summary') {
        this.editIconState.summaryFormShow = !this.editIconState.summaryFormShow;
      }
      if (e.target.id === 'need-individuals') {
        this.editIconState.individualsFormShow = !this.editIconState.individualsFormShow;
      }
      if (e.target.id === 'duration') {
        this.editIconState.durationFormShow = !this.editIconState.durationFormShow;
      }
      if (e.target.id === 'fullTime') {
        this.editIconState.fullTimeFormShow = !this.editIconState.fullTimeFormShow;
      }
      if (e.target.id === 'employer') {
        this.editIconState.employerFormShow = !this.editIconState.employerFormShow;
      }
      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }
      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }
      if (e.target.id === 'street') {
        //  this.selectedAddress = this.getCandidateById.street;

        this.editIconState.streetFormShow = !this.editIconState.streetFormShow;
      }

      if (e.target.id === 'employment') {
        this.editIconState.employmentFormShow = !this.editIconState.employmentFormShow;
      }

      if (e.target.id === 'advertising-start-date') {
        this.editIconState.advertisingStartDateFormShow = !this.editIconState
          .advertisingStartDateFormShow;
      }
      if (e.target.id === 'approval-date') {
        this.editIconState.approvalDateFormShow = !this.editIconState.approvalDateFormShow;
      }
      if (e.target.id === 'advertising-end-date') {
        this.editIconState.advertisingEndDateFormShow = !this.editIconState
          .advertisingEndDateFormShow;
      }
      if (e.target.id === 'competences-required') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesRequiredFormShow = !this.editIconState
          .competencesRequiredFormShow;
      }
      if (e.target.id === 'competences-advantage') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesAdvantageFormShow = !this.editIconState
          .competencesAdvantageFormShow;
      }
      if (e.target.id === 'promoted') {
        this.editIconState.promotedFormShow = !this.editIconState.promotedFormShow;
      }
      if (e.target.id === 'created-by') {
        this.editIconState.createdByFormShow = !this.editIconState.createdByFormShow;
      }
      if (e.target.id === 'created-date') {
        this.editIconState.createdAtFormShow = !this.editIconState.createdAtFormShow;
      }
      if (e.target.id === 'lastUpdated') {
        this.editIconState.lastUpdatedFormShow = !this.editIconState.lastUpdatedFormShow;
      }
      if (e.target.id === 'years-of-experience') {
        this.editIconState.yearsOfExperianceFormShow = !this.editIconState
          .yearsOfExperianceFormShow;
      }
      if (e.target.id === 'degreeField') {
        this.editIconState.degreeFormShow = !this.editIconState.degreeFormShow;
      }
      if (e.target.id === 'degree-field') {
        this.editIconState.degreeFieldFormShow = !this.editIconState.degreeFieldFormShow;
      }
      if (e.target.id === 'languages') {
        this.editIconState.languagesFormShow = !this.editIconState.languagesFormShow;
      }
      if (e.target.id === 'postal') {
        this.editIconState.postalFormShow = !this.editIconState.postalFormShow;
      }
      if (e.target.id === 'relocation') {
        this.editIconState.relocationFormShow = !this.editIconState.relocationFormShow;
      }
    },
    setNewAvatar() {
      this.retrieveJobAdById(this.$route.params.job_uuid).then(() => {
        this.selectedAvatar = this.getJobAdById.photo;
      });
    },
    addCommentHandler(comment) {
      if (comment) {
        const normalizedComment = comment.trim();

        this.addJobAdComment({
          uuid: this.$route.params.job_uuid,
          message: normalizedComment,
        })
          .then(() => {
            this.retrieveJobComments({ uuid: this.$route.params.job_uuid });

            this.$toasted.show(MESSAGES.commentAddedSuccess, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$toasted.info(MESSAGES.emptyComment, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
    editCommentHandler(commentData) {
      this.editJobAdComment({ uuid: commentData.id, data: commentData.comment })
        .then(() => {
          this.retrieveJobComments({ uuid: this.$route.params.job_uuid });
          this.$toasted.success(MESSAGES.commentUpdatedSuccess, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(MESSAGES.commentUpdatedError, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    deleteCommentHandler(commentID) {
      this.removeJobAdComment({ uuid: commentID })
        .then(() => {
          this.retrieveCandidateComments({ uuid: this.$route.params.candidate_id });

          this.$toasted.show(MESSAGES.commentDeletedSuccess, {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    reloadActivity() {
      this.retrieveActivitiesForJob({
        jobad_id: this.$route.params.job_uuid,
        page: 1,
        count: 10,
      }).then(() => {
        this.currentActivities = this.getActivitiesForJob.data;
        this.last_page = this.getActivitiesForJob.last_page;
      });
    },
    handleSearchFilters() {
      /*  console.log(e); */
    },
    fetchCitiesByCountryId(e) {
      this.selectedCountry = e;

      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    },
    removeJob() {
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/admin/jobad/delete/${this.$route.params.job_uuid}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$refs.closeModalBtn.click();
          this.$router.push({ name: 'admin-jobs' });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    onChangeJobStatus() {
      this.jobStatusModalShow = true;
    },
    onChangeJobServiceLevel() {
      this.jobSourcingModalShow = true;
    },
    saveNewJobStatus() {
      this.isLoading = true;

      this.setJobStatus({
        js_employer_jobad_id: this.$route.params.job_uuid,
        status: this.selectedJobStatus,
      })
        .then(() => {
          this.isLoading = false;
          this.jobStatusModalShow = false;

          this.$toasted.success(
            `Job Status changed from ${this.getJobStatusMixin(this.actualJobStatus).title} to ${
              this.getJobStatusMixin(this.selectedJobStatus).title
            }`,
            {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            },
          );

          this.actualJobStatus = this.selectedJobStatus;
        })
        .catch(err => {
          this.$toasted.error(`${err}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onCancelSetJobStatus() {
      this.jobStatusModalShow = false;
      this.selectedJobStatus = this.actualJobStatus;
    },
    onCancelSetServiceLevel() {
      this.jobSourcingModalShow = false;
      this.selectedServiceLevel = this.actualServiceLevel;
    },
    forceRerender() {
      this.key += 1;
    },

    getJobAd() {
      this.retrieveJobAdById(this.$route.params.job_uuid)
        .then((/* { data } */) => {
          /* Default values */
          this.selectedJobTitle = this.getJobAdById.title;
          this.selectedCountry = this.getJobAdById.country;
          this.selectedCity = this.getJobAdById.city;
          this.selectedYearsExperience = this.getJobAdById.years_experience;
          this.selectedDegreeType = this.getJobAdById.degree_type;
          this.selectedEmploymentType = this.getJobAdById.employment_type;
          this.selectedRelocation = this.getJobAdById.relocation;
          this.selectedServiceLevel = this.getJobAdById.service_level;
          this.actualServiceLevel = this.getJobAdById.service_level;
          this.selectedPromoted = this.getJobAdById.promoted;
          this.selectedIndividuals = this.getJobAdById.individuals_number;
          this.selectedFullTime = this.getJobAdById.full_time;
          this.selectedDuration = this.getJobAdById.duration;
          this.selectedSummary = this.getJobAdById.summary;
          this.selectedWorkplace = this.getJobAdById.workplace;
          this.selectedAnon = this.getJobAdById.anonymize;
          this.selectedTest.id = this.getJobAdById.devskiller_test_id;
          this.selectedTest.name = this.getJobAdById.devskiller_test_name;
          this.selectedStartingFee = this.getJobAdById.starting_fee;
          this.selectedRecruitingFee = this.getJobAdById.recruiting_fee;
          this.selectedProgrammingTestFee = this.getJobAdById.programming_test_fee;
          this.selectedCurrency = this.getJobAdById.currency;
          this.fetchCitiesByCountryId(this.getJobAdById.country);
          this.selectedCompetences = this.getJobAdById.required_competences.map(c => {
            return { ...c, id: c.competence_id };
          });
          this.selectedCompetencesAdvantage = this.getJobAdById.advantage_competences.map(c => {
            return { ...c, id: c.competence_id };
          });
          this.selectedLanguages = this.getJobAdById.languages.map(l => {
            return { ...l, id: l.language_id };
          });
          this.selectedDegreeField - this.getJobAdById.degree_field;
          this.selectedAddress = this.getJobAdById.street;
          this.selectedJobStatus = this.getJobAdById.status;
          this.actualJobStatus = this.getJobAdById.status;
          this.selectedId = this.getJobAdById.js_employer_id;
          this.selectedAvatar = this.getJobAdById.photo;
          this.selectedEndDate = this.getJobAdById.advertizing_end_date;
          this.selectedPostalCode = this.getJobAdById.postal_code;
          this.selectedDescription = this.getJobAdById.description;
          const platsbanken = this.getJobAdById.platsbanken;

          if (
            !platsbanken ||
            Array.isArray(platsbanken) ||
            platsbanken.platsbanken_description === null ||
            platsbanken.platsbanken_description === undefined
          ) {
            this.plats_advertising.description = this.sanitizeDescription(this.selectedDescription);
          } else {
            this.plats_advertising.description = this.sanitizeDescription(
              platsbanken.platsbanken_description,
            );
          }

          /* End Default values */
          this.isLoading = false;
          this.setAdvertising();
          this.updateMeta();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    changeGlobalEditMode() {
      this.selectedCountry = this.getJobAdById.country;
      this.selectedCity = this.getJobAdById.city;
      this.selectedJobTitle = this.getJobAdById.title;
      this.selectedYearsExperience = this.getJobAdById.years_experience;
      this.selectedDegreeType = this.getJobAdById.degree_type;
      this.selectedDegreeField = this.getJobAdById.degree_field;
      this.selectedCompetences = this.getJobAdById.required_competences;
      this.selectedCompetencesAdvantage = this.getJobAdById.advantage_competences;
      this.selectedEmploymentType = this.getJobAdById.employment_type;
      this.selectedPromoted = this.getJobAdById.promoted;
      this.selectedPostalCode = this.getJobAdById.postal_code;
      this.selectedRelocation = this.getJobAdById.relocation;
      this.selectedIndividuals = this.getJobAdById.individuals_number;
      this.selectedFullTime = this.getJobAdById.full_time;
      this.selectedDuration = this.getJobAdById.duration;
      this.selectedSummary = this.getJobAdById.summary;
      this.selectedWorkplace = this.getJobAdById.workplace;
      this.selectedAnon = this.getJobAdById.anonymize;
      this.selectedTest.id = this.getJobAdById.devskiller_test_id;
      this.selectedTest.name = this.getJobAdById.devskiller_test_name;
      this.selectedStartingFee = this.getJobAdById.starting_fee;
      this.selectedRecruitingFee = this.getJobAdById.recruiting_fee;
      this.selectedProgrammingTestFe = this.getJobAdById.programming_test_fee;
      this.selectedCurrency = this.getJobAdById.currency;
      this.selectedEndDate = this.getJobAdById.advertizing_end_date;
      this.selectedCompetences = this.getJobAdById.required_competences.map(c => {
        return { ...c, id: c.competence_id };
      });
      this.selectedCompetencesAdvantage = this.getJobAdById.advantage_competences.map(c => {
        return { ...c, id: c.competence_id };
      });
      // this.selectedDescription = this.removeHtmlTags(this.getJobAdById.description, 'p');
      this.selectedDescription = this.getJobAdById.description;
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },
    updateJobAd() {
      if (!this.selectedCity || !this.selectedCountry) {
        this.$toasted.error(`Please enter City and Country before editing other information`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else {
        this.updateJobAdById({
          js_employer_jobad_id: this.$route.params.job_uuid,
          employer_id: this.getJobAdById.js_employer_id,
          title: this.selectedJobTitle,
          description: this.selectedDescription,
          city_id: this.selectedCity.id,
          country_id: this.selectedCountry.id,
          employment_type: this.selectedEmploymentType,
          years_experience: this.selectedYearsExperience,
          degree_type: this.selectedDegreeType,
          degree_field: this.selectedDegreeField,
          competences: this.selectedCompetences.map(c => c.id),
          advantage_competences: this.selectedCompetencesAdvantage.map(c => c.id),
          languages: this.selectedLanguages.map(l => l.id),
          relocation: this.selectedRelocation,
          street: this.selectedAddress,
          advertizing_end_date: this.selectedEndDate,
          summary: this.selectedSummary,
          /* end_date: this.endDate, */
          comments: this.comments,
          saved_status: 1,
          promoted: this.selectedPromoted,
          postal_code: this.selectedPostalCode,
          individuals_number: Number(this.selectedIndividuals),
          full_time: this.selectedFullTime,
          duration: Number(this.selectedDuration),
          workplace: this.selectedWorkplace,
          anonymize: this.selectedAnon,
          devskiller_test_name: this.selectedTest.name,
          devskiller_test_id: this.selectedTest.id,
          starting_fee: this.selectedStartingFee,
          recruiting_fee: this.selectedRecruitingFee,
          programming_test_fee: this.selectedProgrammingTestFee,
          currency_id: this.selectedCurrency.id,
        })
          .then(() => {
            this.editText = false;
            this.retrieveJobAdById(this.$route.params.job_uuid).then(() => {
              /* Default values */
              this.selectedJobTitle = this.getJobAdById.title;
              this.selectedCountry = this.getJobAdById.country;
              this.selectedCity = this.getJobAdById.city;
              this.selectedYearsExperience = this.getJobAdById.years_experience;
              this.selectedDegreeType = this.getJobAdById.degree_type;
              this.selectedJobStatus = this.getJobAdById.status;
              this.actualJobStatus = this.getJobAdById.status;
              this.selectedPromoted = this.getJobAdById.promoted;
              this.selectedServiceLevel = this.getJobAdById.service_level;
              this.actualServiceLevel = this.getJobAdById.service_level;
              this.selectedIndividuals = this.getJobAdById.individuals_number;
              this.selectedFullTime = this.getJobAdById.full_time;
              this.selectedSummary = this.getJobAdById.summary;
              this.selectedDuration = Number(this.getJobAdById.duration);
              this.selectedWorkplace = this.getJobAdById.workplace;
              this.selectedAnon = this.getJobAdById.anonymize;
              this.selectedTest.id = this.getJobAdById.devskiller_test_id;
              this.selectedTest.name = this.getJobAdById.devskiller_test_name;
              this.selectedStartingFee = this.getJobAdById.starting_fee;
              this.selectedRecruitingFee = this.getJobAdById.recruiting_fee;
              this.selectedProgrammingTestFe = this.getJobAdById.programming_test_fee;
              this.selectedCurrency = this.getJobAdById.currency;
              this.selectedEndDate = this.getJobAdById.advertizing_end_date;
              this.selectedCompetences = this.getJobAdById.required_competences.map(c => {
                return { ...c, id: c.competence_id };
              });
              this.selectedCompetencesAdvantage = this.getJobAdById.advantage_competences.map(c => {
                return { ...c, id: c.competence_id };
              });
              this.selectedLanguages = this.getJobAdById.languages.map(l => {
                return { ...l, id: l.language_id };
              });
              this.selectedDegreeField - this.getJobAdById.degree_field;
              this.selectedAddress = this.getJobAdById.street;
              this.selectedId = this.getJobAdById.js_employer_id;
              /* End Default values */
            });

            this.$toasted.success(MESSAGES.updateJobAdSuccess, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            });

            for (const field in this.editIconState) {
              this.editIconState[field] = false;
            }
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });

        this.isInGlobalEditMode = false;
      }
    },
    calculateDuration(duration) {
      if (Number(duration) === 1) {
        return 'Permanent employment';
      } else if (Number(duration) === 2) {
        return 'Time-limited employment';
      } else if (Number(duration) === 3) {
        return 'Less than 1 month';
      } else if (Number(duration) === 4) {
        return '1-3 months';
      } else if (Number(duration) === 5) {
        return '3-6 months';
      } else if (Number(duration) === 6) {
        return '6-12 months';
      } else if (Number(duration) === 7) {
        return 'More than 12 months';
      }
    },
    updateServiceLevel() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/jobad/servicelevel `,
          {
            js_employer_jobad_id: this.$route.params.job_uuid,
            service_level: this.selectedServiceLevel,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.jobSourcingModalShow = false;
          this.$toasted.success(MESSAGES.updateJobAdSuccess, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
          this.getJobAd();
        })
        .catch(err => {
          this.$toasted.error('Cannot change the service level of job with pipelines.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    setAdvertising() {
      if (this.getJobAdById.platsbanken.length === 0) {
        this.plats_advertising.title = this.getJobAdById.title;
        this.plats_advertising.tracking =
          '?utm_medium=platsbanken_advertising&amp;utm_campaign=platsbanken_referral&amp;utm_id=platsbanken';
        this.plats_advertising.link =
          'https://arbetsformedlingen.se/platsbanken/annonser?q=comstream';
      } else {
        this.plats_advertising.platsbanken_id = this.getJobAdById.platsbanken.platsbanken_id;
        if (this.getJobAdById.platsbanken.platsbanken_status === 'PUBLISHED') {
          this.plats_advertising.published = true;
        } else {
          this.plats_advertising.published = false;
        }
        this.plats_advertising.title = this.getJobAdById.platsbanken.platsbanken_title;
        this.plats_advertising.professionId = {
          code: this.getJobAdById.platsbanken.platsbanken_tracking_profession_code,
          name: this.getJobAdById.platsbanken.platsbanken_tracking_profession,
        };
        /*           'taxonomy/type': 'municipality',
        'taxonomy/definition': 'Skövde',
        'taxonomy/id': 'fqAy_4ji_Lz2',
        'taxonomy/preferred-label': 'Skövde', */
        this.plats_advertising.manu = {
          'taxonomy/preferred-label': this.getJobAdById.platsbanken
            .platsbanken_tracking_municipality,
          'taxonomy/id': this.getJobAdById.platsbanken.platsbanken_tracking_municipality_code,
        };

        this.plats_advertising.skills = this.getJobAdById.platsbanken.platsbanken_skills;

        this.plats_advertising.wage = this.getJobAdById.platsbanken.platsbanken_wage_type_code;
        this.plats_advertising.duration = this.getJobAdById.platsbanken.platsbanken_duration_code;
        this.plats_advertising.worktime = this.getJobAdById.platsbanken.platsbanken_worktime_extent_code;
        this.plats_advertising.experience = this.getJobAdById.platsbanken.platsbanken_experience_code;

        this.plats_advertising.startDate = this.getJobAdById.platsbanken.platsbanken_start_date.split(
          ' ',
        )[0];
        this.plats_advertising.endDate = this.getJobAdById.platsbanken.platsbanken_end_date.split(
          ' ',
        )[0];

        this.plats_advertising.tracking = this.getJobAdById.platsbanken.platsbanken_tracking_string;
        this.plats_advertising.link = this.getJobAdById.platsbanken.platsbanken_url;
        if (this.getJobAdById.platsbanken.platsbanken_url.length > 0) {
          this.plats_advertising.link = this.getJobAdById.platsbanken.platsbanken_url;
        } else {
          this.plats_advertising.link =
            'https://arbetsformedlingen.se/platsbanken/annonser?q=comstream';
        }
      }
    },

    getDevSkillerTests() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/admin/devskiller/getalltests`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.DevSkillerTests = res.data;
        })
        .catch(err => {
          /* Tool Tip Here */
        });
    },

    getCurrencies() {
      axios(`${process.env.VUE_APP_API_URL}/common/currency/all`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.currencies = res.data;
      });
    },

    formatForDateInput(raw) {
      // 1. split off the date part ("06-06-25")
      const [datePart /* "06-06-25" */ /* timePart = "03:00" */] = raw.split(' ');
      // 2. split into [yy, mm, dd]
      const [yy, mm, dd] = datePart.split('-');
      // 3. expand "yy" to four digits.
      //    Here we assume "25" means 2025, "06" means 2006, etc.
      //    (You can adapt this rule to your own two-digit logic.)
      const twoDigit = parseInt(yy, 10);
      // grab current two-digit year (e.g. 25 in 2025)
      const nowTwoDigit = new Date().getFullYear() % 100;
      let fullYear;
      if (twoDigit <= nowTwoDigit) {
        fullYear = 2000 + twoDigit;
      } else {
        fullYear = 1900 + twoDigit;
      }
      // 4. build "YYYY-MM-DD"
      //    (mm and dd are already two-digit in your input)
      return `${fullYear.toString().padStart(4, '0')}-${mm}-${dd}`;
    },
  },

  computed: {
    ...mapGetters([
      'getAccType',
      'getJobAdById',
      'getUserProfile',
      'getAllCountries',
      'getJobAdCommentsList',
      'getCitiesListByCountry',
      'getActivitiesForJob',
      'getLanguagesList',
      'getCompetencesFilterList',
    ]),

    dateTimeFormat() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getUserProfile.format_date} HH:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },

    sortedManipucility() {
      return [...this.manipucility].sort((a, b) =>
        a['taxonomy/preferred-label'].localeCompare(b['taxonomy/preferred-label']),
      );
    },
  },
  updated() {
    this.jobAdData = this.getJobAdById;
  },
  mounted() {
    this.isLoading = true;
    this.seenProfile();
    this.getJobAd();
    this.getAllProfession();
    this.getAllSkills();
    this.retrieveUserProfile().then(() => {
      this.retrieveJobComments({ uuid: this.$route.params.job_uuid });

      this.retrieveCompetencesList();
      this.retrieveActivitiesForJob({
        jobad_id: this.$route.params.job_uuid,
        page: 1,
        count: 10,
      })
        .then(() => {
          this.isLoading = false;
          this.currentActivities = this.getActivitiesForJob.data;
          this.last_page = this.getActivitiesForJob.last_page;
        })
        .catch(() => (this.isLoading = false));
      //  this.sendManagerRecent({ jobad_id: this.$route.params.jobad_id });
    });
    this.retrieveSourcesList();
    this.getCurrencies();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.jobshark-header {
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #ddd;
  margin: 30px 0 25px 0;
  padding-bottom: 12px;
}
.advertising {
  font-family: $font-family-sans-lato;
  padding: 40px 20px;
  .form-group {
    margin-bottom: 20px;
    label {
      font-size: 14px;
      font-weight: 700;
    }
  }
  .view-link {
    .btn-outline {
      color: red;
      width: 31px;
      height: 31px;
      &:first-of-type {
        color: green;
      }
    }
    &:hover {
      .show {
        opacity: 1 !important;
      }
    }
  }
}

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.ql-snow {
  min-height: 580px;
}
.job-details {
  .edit-fields {
    width: 100%;
    padding-left: 15px;
  }
  span.edit-label {
    font-weight: 700;
    padding-top: 10px;
    width: 150px;
    flex-shrink: 0;
    &.last {
      width: 75px;
    }
  }
}

.job-details-description {
  li {
    span {
      width: 170px;
    }
    div {
      flex: 1;
    }
    .icon-container {
      flex: 0;
      min-width: 120px;
      padding: 0 20px;
    }
  }
}

.job-edit {
  &-icon {
    fill: #a3a6b4;
    margin-top: -5px;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.custom-card {
  height: 895px !important;
  overflow: hidden;
}

.job-content {
  overflow: auto;
  height: 895px !important;
}

#description {
  padding: 0 24px;
}
.card {
  margin: 0;
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  li {
    position: relative;
  }

  .icon-container {
    position: relative;
    padding-left: 20px;
  }

  li span {
    display: inline-block;
    font-weight: 700;
    &.icon-container {
      position: relative;
    }
  }
  .empl-icon {
    position: absolute;
    display: inline-block;
    top: 50%;
    transform: translate(0, -50%);
    left: -45px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #ddd;
      border-radius: 50%;
    }
  }

  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  overflow: hidden;

  .row {
    margin: 0;
  }

  li.list-group-item {
    padding-left: 0 !important;
    border: none !important;
    padding-right: 0;
    b {
      font-weight: 600 !important;
    }
  }

  li > .d-flex {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    margin: 3px 12px;
    padding: 12px 0;
    height: 46px;
    flex: 1;
    align-items: center;
  }

  li span {
    min-width: 110px !important;

    white-space: nowrap;
  }

  li > span:not(:nth-child(2n + 0)) {
    font-weight: 700;
    min-width: 19rem;
  }

  .popup {
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    padding: 8px 12px 6px 12px !important;
    top: 75%;
    left: -15px;
    width: 100%;
    height: auto !important;
    z-index: 9;
    flex-wrap: wrap;
  }

  .tech-icons {
    width: 100%;
    position: relative;
    margin-top: -20px;
    .icon-container {
      min-width: 100px;
      text-align: center;
      display: inline-block;
      &:first-of-type {
        pointer-events: none;
        padding-left: 0 !important;
        margin-left: -30px;
      }
      .icon-wrapper {
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .btn-secondary {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      position: absolute;
      top: 13px;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .dropdown-menu {
      width: 100%;
      border-radius: 0;
      .list-inline {
        li {
          margin: 0;
          text-align: center;
          width: 25%;
        }
      }
    }
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  .edit-btn {
    position: absolute;
    left: 0;
    .edit-icon {
      color: #666;
    }
  }
}

/deep/ .description-text {
  h6 {
    font-size: 1.125rem;
    font-weight: 700;
  }

  &-body {
    font-size: 0.875rem;
    font-family: $font-family-sans-lato;
  }
}

/* Title Header */
.job-edit {
  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.header-title {
  width: 100%;
  padding: 25px 0 5px 6px;

  &-name {
    font: 21px Montserrat;
    letter-spacing: 0;
    color: #000;
    flex: 1;
  }
  .single-job-controls {
    margin-left: 6px;
  }

  .name-edit {
    flex-shrink: 0;
  }
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #ddd;
  padding-left: 0;

  .btn {
    background-color: #fff;
    border: 1px solid rgba(60, 60, 60, 0.26) !important;
    width: 24px;
    height: 24px;
    margin-left: 5px;
    font-size: 12px;
    flex-shrink: 0;
    border-radius: 5px;
    padding: 0;
    align-items: center;
    justify-content: center;
    text-align: center;
    .fa-check {
      color: green;
    }
    .fa-times {
      color: Red;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin-top: 26px !important;
  }
  .job-aside-activity {
    display: none !important;
  }
  .desktop-pipelines {
    padding: 0 23px;
  }
}

@media only screen and (max-width: 992px) {
  .mobile-clear {
    padding: 0 17px;
  }
  #description {
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 768px) {
  #description {
    .job-details {
      .list-group-item {
        padding-left: 0 !important;
      }
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 12px;
      .container {
        max-width: 100%;
      }
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 576px) {
  .header-title {
    width: 100%;
    padding: 25px 0 5px 6px;

    &-name {
      font: 18px Montserrat;
      letter-spacing: 0;
      color: #000;
      flex: 1;
    }
    .single-job-controls {
      margin-left: 6px;
    }

    .name-edit {
      flex-shrink: 0;
    }
  }

  #description {
    padding: 0;
    overflow: hidden;
    .card {
      margin: 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 70px;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      .req {
        min-height: 100vh;
      }
    }
    .tab-content {
      margin: 0;
    }
    .description-scroll {
      max-height: none;
    }
    .single-job-controls {
      margin-top: 20px;
      .select-style {
        position: relative;
        left: 0;
        max-width: 75%;
      }
      button {
        margin-left: auto !important;
      }
    }
    .mobile-only {
      display: block !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .comments {
    padding: 8px;
  }
  .req-mobile {
    margin-top: 31px !important;
  }
}

.tech-icons {
  margin-top: -30px;
  img {
    width: 30px;
    height: auto;
  }
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin-top: 15px;

  li {
    display: inline-flex;

    .item-title {
      white-space: nowrap;
      font-weight: 700;
      margin-right: 20px;
    }

    .item-body {
    }
    &:nth-of-type(4) {
      .item-body {
        .tech-icons {
          margin-top: 0;
        }
      }
    }
  }
  .candidate-tag {
    border: 1px solid #a3a6b4;
    border-radius: 20px;
    color: #a3a6b4;
    padding: 6px 10px;
  }

  .candidate-tag-selected {
    color: $color-orange;
    border: 1px solid $color-orange;
  }

  .list-group {
    padding-left: 5px;
  }
  .tech-icons {
    position: relative;
    .show-more-icons {
      position: absolute;
      top: 123%;
      left: -5px;
      width: auto;
      max-width: 100%;
      background: #fff;
      border: 1px solid #ddd;
      z-index: 9;
      flex-wrap: wrap;
      .d-flex {
        padding: 12px 6px 6px 10px;
      }
      .icon-container {
        margin-right: 23px;
      }
    }
    .show-more-icons.second {
      left: -14px;
    }
    .collapsing {
      -webkit-transition: unset !important;
      transition: unset !important;
    }
  }
  .job-details {
    li {
      padding-left: 12px;
    }
  }
  /* Resetting utility class */
  .description-text {
    padding: 0 !important;
  }
}
</style>
